// The Estée Lauder Companies AI Lab mock pack — the demo's scripted question
// and its full typed-block response (block kinds → pages/Lab/blocks/index.js).
// Same authoring law as mock/lab/starbucks.js: readout first and VERDICT
// ONLY, CMO cultural-capital vocabulary (never engine internals), NAMED
// moves, digit-free modelView, provenance observed / projected / measured.
// Pure data, no imports (scripts/dump-lab-fixture.js evaluates the file).
//
// What matters for Estée Lauder (user brief 2026-09-25): the house is a
// PORTFOLIO — the tracked brand on the board is the parent (listing EL is a
// parent proxy, the eponymous brand a minority of group revenue) and the
// question a Chief Brand Officer asks of it is which of the brands the
// company owns carry a fandom the parent never spends. ONE scripted
// question (user call: one entry, built deep; sibling questions come
// later the way the Starbucks pack grew), on the `fandom` starter type
// (chip art, tag and think script reused) with `community` as its item
// type — a fandom on a sub-brand is a crowd you keep, not a partner you
// rent.
//
// "Untapped" is two things set against each other, never an absence (the
// collabs rule: a read finding nothing is a limit of our search, never
// proof a play went unnoticed): FANDOM is what the crowd makes, trades and
// argues about on its own — dupes and decants, the comeback petitions, the
// hacks, the nostalgia genre, the connoisseur trade; ACTIVATION is what the
// parent put behind the brand in the last two years — ambassadors, launches,
// campaigns, doors, and the opposite: a sale attempt, an impairment, a
// closed headquarters. Untapped = loud crowd, quiet parent. The whole
// owned portfolio is on the map (user call: "the whole portfolio the
// company owns"), founded brands in grey so the acquired ones stay the
// answer; licensed lines (AERIN, Balmain, Donna Karan, Michael Kors) and
// closed brands (Becca, Rodin, Prescriptives) are not owned brands in the
// sense of the question and are left off, as are the dormant ones with no
// crowd to read (Aramis, Lab Series, Darphin, GlamGlow).
//
// Numbers + references are calibrated to the LIVE dev DB (2026-08-24 run,
// queried 2026-09-25): Estée Lauder CIQ 50.5 served, climbing from 43.4 in
// March across thirteen windows (48.2 late June, 51.1 mid-August); 84 items
// on the record, all the eponymous brand's — Double Wear's reformulation
// and pop-ups, Advanced Night Repair, the Glimmer fragrance with Hailee
// Steinfeld, IU and Zhu Yilong in Asia — and exactly ONE portfolio play the
// index measured: The Ordinary's PDRN pop-up of 2026-04-02, read seven
// times through August (the one measured dot on the map; every other
// brand's position is MODELLED from public evidence). Press and search
// track the parent name only. MEASURED = the parent's own record;
// PROJECTED = everything on the sub-brands and every move's price;
// OBSERVED = the field's dated public facts.
//
// Public evidence behind the map (all dated, gathered 2026-09-25):
// TOO FACED — Chocolate Bar palette discontinued, petitions and resale
// premiums since, Better Than Sex still the category's mascara reference;
// the parent: a $50M impairment in FY25, put up for sale January 2026,
// kept July 14, the Irvine headquarters closed and 67 roles cut through
// December, folded into the MAC / Bobbi Brown makeup cluster; FY26 "net
// sales declined". DR.JART+ — Cicapair's green colour corrector a
// cross-market viral redness fix, creators repurchasing on camera and
// openly discussing the brand being "put up for sale"; the parent: last
// global push Enhypen as ambassadors October 2023, then a $375M
// impairment, a sale explored, kept with a leaner Korea team, no mention
// in FY26 commentary. AVEDA — "perfume that smells like Shampure" is a
// TikTok genre of its own, home recipes and diffuser dupes, the scent
// thirty-five years old; the parent: FY26 "net sales declined … exit from
// underperforming doors, including some of its own freestanding stores …
// continued challenges in the salon channel", the strategy "the salon at
// the centre". BUMBLE AND BUMBLE — Hairdresser's Invisible Oil the
// bestseller on hairtok, Surf Spray a cult, and Charli XCX's A24 film The
// Moment (Sundance, January 2026) hair-designed by a Bb collaborator; the
// follow-up a SalonCentric wholesale deal (850 stores, February 2026), no
// consumer campaign. SMASHBOX — the original Photo Finish primer a cult
// with NYX and Maybelline dupes; a Canada-only relaunch June 2026, the LA
// team "significantly streamlined". FRÉDÉRIC MALLE — Portrait of a Lady
// inducted into the Fragrance Foundation Hall of Fame 2026, a deep
// connoisseur base rating the pre-acquisition editions higher; the
// founder gone since June 2024, no ambassador, two quiet 2026 editions.
// BOBBI BROWN — a loyalist base that complains about discontinuations and
// drifts to the founder's Jones Road; one reformulation in twenty years
// (Vitamin Enriched Face Base+, July 2026, Sara Foster); FY26 "continued
// declines in lip and eye". ORIGINS — Mega-Mushroom nostalgia and a
// counterfeit market; moved under DECIEM's digital-first model August
// 2026, no campaign yet. The tended half: THE ORDINARY (a TikTok Shop
// brand whose fans' glycolic-on-scalp hack became a commissioned clinical
// study; #2 US skincare by value 2025), CLINIQUE (Black Honey past a
// billion views, "seven a minute", a lipliner, a pop-up and the house's
// first creator-led campaign March 2026; #1 US skincare by value), MAC
// (Sephora US March 2026, Chappell Roan on Viva Glam, Basquiat this fall;
// "#1 prestige makeup brand in the US" Q4 FY26), LE LABO (Santal 33's
// Costco restock cycles, city exclusives, Violette 30, Shiu 25; led FY26
// fragrance growth), TOM FORD (Lost Cherry's dupe economy, Figue Érotique,
// a billion-dollar brand after a $549M write-down), KILIAN (Angels' Share
// on perfumetok, the Cocktail Collection at Sephora August 2026, 32
// boutiques), JO MALONE (Wood Sage & Sea Salt duped by Zara with the
// founder herself; two ambassador campaigns in 2026, a scent-layering
// filter; crossed a billion), LA MER (the Nivea dupe discourse; Jay Chou,
// a Year of the Horse pop-up). Parent: FY26 net sales $15.0B, +5%, six
// billion-dollar brands, fragrance +10%, makeup flat, hair −1%; ten
// thousand positions cut under Beauty Reimagined; the Too Faced /
// Smashbox / Dr.Jart+ sale explored January to May 2026 and withdrawn in
// a July memo with "indie" operating models; Puig talks March to May,
// terminated. The map's x is the crowd's own volume (dupes, petitions,
// hacks, trade) and y is how little the parent spent, both on a 0 to 100
// scale; dot size is the brand's weight in the house; the trend and the
// prices are illustrative indexes on that record.
//
// THE BEAUTY FIELD (user call 2026-09-25: "we should analyze other brands
// from the beauty industry we have data on … find opportunity based on
// industry stats, early trends, strategies"): the five beauty brands on the
// board at 2026-08-24, board rank computed at read time over 36 enabled
// brands — Rhode #28 at 57.7 (41.4 in May; 17 fandom-coded plays, 18
// merch, scarcity fit 0.59, the deepest fandom record in beauty; "viral"
// in a third of its rows), Sephora #30 at 54.4 (42.9 in May; 94 items,
// event-led; Edinburgh store launch received +73, Summer Club +53, Quiet
// Hours +47, Marc Jacobs Beauty global relaunch 37.6 the field's best
// comeback, Olive Young edit 40.3 / 39.6, "Mario's Beauty Booth" TikTok
// series 29.4), Aesop #31 at 53.4 (44.4 → 57.7 in July → 53.4; the
// Factory of Light 53.4 base received 80 — the strongest play in beauty —
// the Queer Library +67; persistent tier in the 90s; no fan language
// anywhere on its record), Estée Lauder #34 at 50.5 (ZERO fandom-coded
// plays of 84; aesthetic_innovation on 25; Skin Longevity Institute 45.4
// its best play, read 30 in May and not since; Nia Long campaign 33.8
// received 65; Travel Retail × Stanley 36.1 received 30; Sensuous Nude
// relaunch 28.2), OUAI #35 at 44.7 (30.7 in May, the steepest climb;
// reissue-led — Body Crème Shibuya 34.0 "brought back", Palo Santo
// leave-in 33.3; "cult", "TikTok", "bring back" on 14 of 54 rows). Fandom
// plays across the whole category: 25, seventeen of them Rhode's; no
// beauty episodic play graded above the mid-fifties against the board's
// crowd-shot ceiling (Apple 88.4). The arena's bands are per-lane typical
// (median) and ceiling (upper quartile) of graded strength across the five
// brands' episodic plays, its rings the class maxima, its dots the house's
// own bases; the matrix is each brand's strategy-row count on one scale
// across the grid (25 = 100); the shift's sparklines are the served score
// by window. Precedents in `similar` rows are the beauty cohort's measured
// plays first, then the board's cross-industry ceiling.
//
// The three moves are the largest fandom-minus-activation gaps on the map
// (user call: let the quadrant choose), priced on the PARENT's served
// CIQ in the sibling labs' range: +1.1 / +0.8 / +0.7 = +2.6, 50.5 → ~53.
// Precedents in `similar` rows are other brands' measured plays from the
// same run (Sephora's Marc Jacobs relaunch 37.6, OUAI's Shibuya reissue
// 34.0, Rhode's lip cases 38.5 and mystery drop 33.5, Ferrari's 250 GTO
// 71.4, Apple's Shot on iPhone 88.4).
//
// THE SECOND QUESTION (2026-09-25, same day): "Why is fragrance gaining
// momentum while makeup is flat?" — a DIAGNOSIS, not a scout, so it got
// its own question type `momentum` ("Momentum lab", chip art in
// Starters.js, think script in stages.js: split the growth into price
// and units, read who walks in and who walks out, read each category's
// plays on the shelf, then price). Item type `capsule` — the drop and the
// restock cycle are the format the growing category runs on. The answer's
// spine, in three registers:
// OBSERVED (public, dated 2026-09-25): the house's FY26 (to June 2026,
// reported 19 Aug 2026) — fragrance +10% organic in every region, led by
// Le Labo, Tom Ford and Kilian (Q3 also named Balmain Beauty); makeup
// "essentially flat" (Q2 −1% on a Double Wear returns accrual, Q3 flat
// with the Estée Lauder brand up double digits on the February Double
// Wear relaunch while Clinique's FOUNDATION lost double digits and Too
// Faced declined, Q4 +2%); skin care +4%, hair −1%; fragrance ≈ $2.8B of
// $15.0B against makeup ≈ $4.3B; Jo Malone London and Tom Ford joined the
// billion-dollar brands; 33 net new fragrance stores opened while MAC
// closed freestanding doors; a North America Fragrance Cluster (June
// 2026) and a Paris Fragrance Atelier; FY27 guide "makeup expected to
// return to growth". The US market (Circana, first half 2026, published
// 11 Aug 2026): prestige beauty +7%; prestige FRAGRANCE +6% in dollars
// with UNITS FLAT and the average price +5% (eau de parfum and parfum
// double-digit, the luxury tier growing); MASS fragrance +15% dollars
// and +7% units, the fastest-growing mass category, on body mists;
// prestige MAKEUP +3% with units softening, lip liner +34% the
// fastest-growing segment, blush and bronzer double-digit; prestige skin
// +9%, hair +11%; mass makeup +5% with units down. The crowd: prestige
// mists' share of fragrance units 7% → 12% in three years (mists +94% in
// 2024), minis 38% of prestige fragrance units, 38% of fragrance spend
// from households with a Gen Z member (26 weeks to July 2025), teenage
// boys' fragrance spend +44% (2024, Piper Sandler); six in ten Gen Z and
// millennials want makeup that is skincare; Korean base makeup on Tmall
// −43.5% in August 2026. Rivals: L'Oréal Luxe fragrance double-digit
// (Prada Paradigm, YSL Libre), Puig niche double-digit on Byredo and
// mists, Interparfums "continued strength of the category", LVMH
// perfumes flat, Coty −5% and the Gucci licence sold back; makeup grows
// at Puig (+9% on Charlotte Tilbury) and Coty (Kylie, Burberry) — an
// identity brand's growth, not a category's. The brand: Glimmer
// (announced 28 Jul 2026, the first new scent since Beautiful Magnolia in
// 2021, an amber-floral gourmand for the Gen Z / millennial prestige
// buyer, Hailee Steinfeld, $130 / 50 ml, one size class); Double Wear's
// first reformulation since 1997 (on shelf 23 Feb 2026, Daisy
// Edgar-Jones and Nia Long, 57 shades, $52 unchanged); Kilian's Cocktail
// Collection at Sephora at 10 ml for $37 (Aug 2026) as the house's one
// bottom rung. MEASURED (dev DB, the 2026-08-24 run, queried 2026-09-25):
// of the 84 items, 12 read as fragrance — Glimmer four times (the
// campaign 26.8 base, the shelf's strongest episodic play, reception
// 1.12–1.18; the teaser received +60, the best-read launch content of
// the year; the limited-quantities capsule praised 47 / criticised 27),
// Pleasures twice (a duo 12.2, the Ladurée box 24.7), Sensuous Nude once
// (28.2 base, the evidence ONE customer review and "no formal relaunch
// campaign", the archive lane at 4.70 — below the 15 imputation floor);
// 36 read as makeup — Double Wear in ≈18 titles (global launch event,
// "A New Era" 33 / 27, masterclasses, Lotte / Kaya Toast / Chicago /
// Harrods pop-ups, sampling bus tours, the Heathrow counter received
// +53, the Flagship Pop-Up Destination 22.3), the Victoria Beckham,
// Sabyasachi and Ladurée lip-oil collaborations SILENT in every window;
// 24 read as skin — Re-Nutriv's paradigm film the best-received item on
// the shelf (+73, reception 1.219), the Skin Longevity Institute 45.4
// the strongest experience, Nia Long's "The One" 32–34 received 60.
// Only 7 of 32 events ever registered a signal (cohort 36%); 88% of all
// pulse windows found nothing. Strategy rows: aesthetic_innovation 25,
// scarcity 8, identity_signal 2, opacity 1, fandom 0 (Rhode 17). Search
// interest 8.65, the weakest in beauty (Rhode 59.6). The matrix rows are
// those counts split by category on the sibling entry's scale (25 = 100)
// — the split by category is an author's read of the titles, the totals
// are the record's. The quadrant's y for the sub-brands is modelled from
// the results commentary; the brand's own three dots from its record.
// PROJECTED: every price and every curve. Three moves at +1.0 / +0.8 /
// +0.7 = +2.5, 50.5 → ~53 — the sibling labs' range.
//
// THE THIRD QUESTION (2026-09-25, same day): "Where's the biggest
// opportunity to win back China without travel retail?" — on the `geo`
// question type (the Starbucks market-scan script and the world-map
// block reused), item type `experience` (the lead move is a room).
// OBSERVED (public, dated 2026-09-25): the house's mainland China FY26
// (reported 19 Aug 2026) +9% organic, six consecutive quarters of share
// gain, ≈$3.06B ≈ a fifth of the group, adjusted operating income +92%,
// by quarter +9 / +13 / +6 / +7; growth led by La Mer, Le Labo (+50% for
// the year), Tom Ford, Jo Malone London, The Ordinary — the Estée Lauder
// brand named only on the festival scoreboards (11.11 2025: #1 prestige
// beauty on Tmall, #1 store livestream on Douyin; 618 2026: #1 on
// Douyin, #2 on Tmall behind SkinCeuticals); China president reporting to
// the CEO, "less promotional", freestanding stores the preferred model,
// online over half of China, Douyin "the core position to recruit new
// consumers", eleven brands on it; travel retail "reset to 15%" (Barclays,
// 9 Sep 2026), mainland duty-free DOWN on the Beijing / Shanghai airport
// operator change, Hainan a separate business (+18.8% H1); the $210M
// daigou settlement (May 2026 — the old China number was duty-free stock
// resold at a discount). Innovation: 30% of the house's global innovation
// from Shanghai "in China, for China" (a Re-Nutriv oil from the China
// Innovation Labs, Dec 2025; an Estée Lauder treatment lotion in the
// global top ten); the Minhang Open Innovation Center (March 2026) — told
// in trade press only. Market: cosmetics retail +6.3% H1 2026, June
// +12.6% (the strongest month since Nov 2024), domestic +7.9% vs foreign
// +1.2% for the half, yet at 618 prestige internationals took the
// scoreboards while beauty overall fell 2.4%; Proya's namesake brand −7%
// H1, Mao Geping +26%; guochao in a "3.0" phase — craft, region and museum
// depth sell, a flag alone does not; Xiaohongshu's triangle "emotion,
// aesthetics, efficacy", "instant repair" the fastest-rising claim; 64% of
// Gen Z buy for emotional satisfaction; Chinese arrivals to Japan −57% in
// August. What rivals did: Lancôme's five-city Lunar New Year pop-ups
// (Chengdu lacquerware teahouse, Xu Beihong horses), Kans × Suzhou Museum
// (6.2M views), Documents' Red House pop-up and Zhu Yilong as its first
// global ambassador (18 Aug 2026), To Summer's artisans, Helena
// Rubinstein's four-city Plump Voyage, Louis Vuitton's Chengdu Chill;
// Le Labo's Wukang Road villa lab at 2,000+ visitors a day and the
// Beijing siheyuan lab with Shiu 25 (Sept 2026). The brand's Chinese
// faces: Xin Zhilei (global makeup, Venice Best Actress 2025), Shu Qi
// (skincare), Wang Manyu (table tennis, makeup), Wang Hedi; the 2026 Lunar
// New Year move found was a global compact — no China pop-up, IP collab or
// trend-city activation surfaced. MEASURED (dev DB, 2026-08-24 run,
// queried 2026-09-25): regions are continent buckets only (GLOBAL / NA /
// EMEA / APAC / LATAM), every run and every metric series GLOBAL — there
// is NO China-scoped search or press series for any brand (a limit of the
// index, said on the chart). The brand's 25 APAC items: three
// mainland-consumer plays — an event with Zhu Yilong 25.8 (28 Jul, never
// read), the Xin Zhilei appointment 23.7 (one niche pulse, then ten
// silent windows), a Liu Haocun film 16.3 (silent); two corporate — the
// Hainan Expo pavilion 17.4 (silent), the Minhang centre 12.3 (read once,
// +40); SEVEN travel-retail plays carrying the ONLY China-adjacent praise
// on the shelf — the Playhouse of Dreams pop-up at cdf Sanya 25.4 (+53),
// the Travel Retail × Stanley set 36.1 (+27), the DVF Changi pop-up 26.8
// (+53), the Heathrow counter 18.3 (+53) — all trade press; five Korea and
// five Singapore plays (the Paragon Atrium pop-up 42.5 is the shelf's #2
// item) all silent; China average base 20.6, the lowest of any brand
// with four or more China plays (Hermès 41.5 the highest). The board's 97
// China plays on 29 brands: what registered was an AUTHORED PLACE —
// Saint Laurent's No. 223 exhibition, Rive Droite Beijing 49.7 (+67),
// Hermès In the Making Shanghai 46.9 / 44.9 (+53 / +60), Louis Vuitton's
// Concept Store Shanghai 43.9 (+60), Nike's Jordan "The One" Shanghai 38.5
// (+60), Valentino's Sanlitun installation (+60) — or a LOCAL PARTNER on
// the box — Luckin × Duolingo latte (+73), Duolingo × MINISO 36.6 (+40),
// McDonald's China × Pop Mart 37.4 (+27), Starbucks × Jay Chou 36.7
// (+33); AMBASSADOR APPEARANCES were silent across the board (Gucci Wuhan,
// UGG, Dior, yours) and the most local-looking play of all — lululemon's
// yoga on the Great Wall — read −80 / −87 for cultural insensitivity.
// Rhode, Sephora and OUAI have no China play. The brand's persistent
// record: brand_codes 73.6 (Estée Blue, the gold cartouche, the little
// brown bottle and its scent); community 40.65 — rituals 20, owned spaces
// 20, exclusivity 0, the E-List "a transactional discount scheme",
// collaborator inbound pull 80, resale depth 60 (the collectible
// compacts). The geoCompare's "presence" index is the record's own
// grades × reads per market on one scale, an author's roll-up; the
// quadrant's x is an author's read of how local each play was.
// PROJECTED: the prices — +1.1 / +0.8 / +0.6 = +2.5, 50.5 → ~53.

export const ESTEE_LAUDER_LAB = {
  brand: "estee-lauder",
  name: "Estée Lauder",
  // the demo persona greeted on the Lab — this Alex is Estée Lauder's own
  // (user call 2026-09-25: a different person from the other packs' Alex,
  // who sees a briefing for this house only)
  person: "Alex",
  // THE WEEKLY PERSPECTIVE's cards (2026-10-21, pages/Leaderboard/WeeklyOne
  // — the user's reference screen IS this brand's card; ONE card again
  // since 2026-10-26, user call: "remove second preview, only one should
  // be proposed, others in archive" — the momentum lab's card, two cards
  // from 2026-10-22, is in git history; the other labs list in the
  // view's ARCHIVE): the China lab under the entry's own words and type
  // (the EXPERIENCES tag), with the reference's own preview verbatim —
  // the trend "+24% Local discovery" (its line's shape traced off the
  // screen), the ring "62% Experience-led intent", the bars "Opportunity
  // by channel" 78 / 64 / 32. The reference's sources count in the
  // overline.
  weekly: {
    sources: 2343289,
    cards: [
      {
        entry: "china-without-travel-retail",
        measured: "2026-10-16",
        preview: {
          trend: {
            value: "+24%",
            label: "Local discovery",
            series: [0, 16, 36, 27, 35, 57, 60, 52, 65, 87, 95],
          },
          ring: { value: 62, label: "Experience-led intent" },
          bars: {
            title: "Opportunity by channel",
            rows: [
              { label: "Local experiences", value: 78 },
              { label: "Social commerce", value: 64 },
              { label: "Travel retail", value: 32 },
            ],
          },
        },
      },
    ],
  },
  entries: [
    {
      id: "portfolio-untapped-fandom",
      // a fandom on a sub-brand is a crowd you keep, not a partner you rent
      itemType: "community",
      type: "fandom",
      question: "Which acquired brands have untapped fan potential?",
      aliases: [
        "which acquired brands have untapped fandom were wasting",
        "which acquired brands have untapped fandom we are wasting",
        "which acquired brands have untapped fandom",
        "which of our brands have untapped fandom",
        "which brands have fandom we are wasting",
        "which brands in the portfolio have untapped fandom",
        "where is the untapped fandom in our portfolio",
        "which acquired brands are we wasting",
        "untapped fandom in the portfolio",
      ],
      askedOn: "2026-09-25",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "The three brands you tried to sell own the fandoms you never spent: Too Faced's palette, Dr.Jart+'s green tube, Aveda's scent — loud crowds, a silent parent.",
        },
        {
          kind: "arena",
          insight:
            "Beauty's fandom is played in three lanes — the drop, the comeback and the crowd's own camera — and the house's strongest dots on every one of them are its acquired brands, not the parent: Le Labo's exclusives, Clinique's revived shade, The Ordinary's crowd-written study; the parent's own plays are ambassadors and pop-ups that read quiet.",
          title: "How the beauty field builds fandom",
          provenance: "observed",
          unit: "strength of the lane's plays · 0–100",
          note: "Bands are the field's range for plays on each lane across the five beauty brands on the board this year — typical to ceiling; the ring is the field's strongest play there, the dots are the house's — the parent's plays from its measured record, its acquired brands' plays placed from public evidence (The Ordinary's pop-up is the one the index read). Received = the best presence measured on the parent's shelf for that lane. Tap a lane for the read.",
          rows: [
            {
              id: "drops",
              label: "Drops & merch",
              sub: "capsule · merch",
              typical: 31,
              ceiling: 38,
              best: {
                brandName: "Rhode",
                title: "Summer Station snap-on lip cases",
                pts: 39,
              },
              received: 65,
              own: [
                {
                  title: "Le Labo · Shiu 25, the Beijing city exclusive",
                  pts: 42,
                },
                { title: "Kilian · Cocktail Collection at Sephora", pts: 36 },
                {
                  title: "Tom Ford · Private Blend Reserve re-releases",
                  pts: 34,
                },
                { title: "Glimmer, limited exclusive", pts: 18 },
                { title: "Advanced Night Repair anniversary set", pts: 17 },
              ],
              note: "Rhode's lane: eighteen merch plays and eleven drops in a season — hoodies, terry bags, a lip case that went viral, a Met Gala mystery drop received at 53, a waitlist that reads 70. The house's best drops are Le Labo's city exclusives and Kilian's ten-millilitre cocktails, both above the field's ceiling; the parent's own three are gift sets and a travel-retail exclusive, graded a third of Rhode's. Aveda has no drop at all — and a scent the crowd is trying to bottle.",
            },
            {
              id: "comeback",
              label: "Comebacks & reissues",
              sub: "archive",
              typical: 30,
              ceiling: 38,
              best: {
                brandName: "Sephora",
                title: "Marc Jacobs Beauty global relaunch",
                pts: 38,
              },
              own: [
                {
                  title:
                    "Clinique · Black Honey, the 1971 shade as a franchise",
                  pts: 46,
                },
                {
                  title:
                    "Bobbi Brown · Face Base+, the first reformulation in twenty years",
                  pts: 30,
                },
                { title: "Sensuous Nude, relaunched", pts: 28 },
              ],
              status: "recommended",
              note: "The lane your Too Faced crowd is petitioning in. Sephora's relaunch of a cult makeup line is the field's best comeback of the year, OUAI's Shibuya body crème came back because its fans asked — and the house's own best play here is Clinique's Black Honey, a revived shade above the whole field. Too Faced has no dot on this lane: the Chocolate Bar has a bigger crowd than any comeback in beauty and has not come back.",
            },
            {
              id: "camera",
              label: "The crowd's camera",
              sub: "content · creators",
              typical: 27,
              ceiling: 40,
              best: {
                brandName: "Sephora",
                title: "Olive Young K-Beauty Edit launch",
                pts: 40,
              },
              received: 80,
              own: [
                {
                  title:
                    "The Ordinary · the fans' scalp hack, run as a clinical study",
                  pts: 46,
                },
                {
                  title:
                    "Clinique · Unstoppable Together, the first creator-led campaign",
                  pts: 38,
                },
                { title: "Nia Long self-care campaign", pts: 34 },
                { title: "Glimmer with Hailee Steinfeld", pts: 27 },
              ],
              note: "Sephora's TikTok series and its Korean edit are the field's carrying content; Rhode's record says 'viral' in a third of its rows. Inside the house, The Ordinary let its crowd write a study and Clinique handed its March campaign to creators — both above the field. The parent's twenty content pieces are ambassador films, none shot by the crowd; Dr.Jart+'s creators already are, and have no dot here because the brand has not asked them.",
            },
            {
              id: "room",
              label: "The room",
              sub: "experience · community",
              typical: 35,
              ceiling: 45,
              best: {
                brandName: "Aesop",
                title: "The Factory of Light, Milan Design Week",
                pts: 53,
              },
              received: 30,
              own: [
                { title: "Skin Longevity Institute", pts: 45 },
                { title: "Paragon Atrium pop-up", pts: 42 },
                { title: "Clinique · the Hot Honey pop-up", pts: 40 },
                { title: "The Ordinary · PDRN pop-up (measured)", pts: 34 },
                { title: "Aveda · the salon chair", pts: 24 },
              ],
              note: "The strongest play in beauty this year is a room — Aesop's Milan installation, received at 80 — and Sephora's Summer Club and Quiet Hours are the best-received community plays. The house's rooms grade well and read quiet: the Skin Longevity Institute was measured at 30 and not read since May; The Ordinary's PDRN pop-up is the one sub-brand play the index saw. Aveda owns the most rooms of any brand in the house — thousands of salon chairs — and the record grades them as a channel, never as a room a crowd comes to.",
            },
            {
              id: "events",
              label: "Fan days & pop-ups",
              sub: "event",
              typical: 25,
              ceiling: 38,
              best: {
                brandName: "Sephora",
                title: "Edinburgh store launch",
                pts: 38,
              },
              own: [
                { title: "MAC · the Sephora US launch", pts: 46 },
                { title: "Double Wear pop-up", pts: 38 },
                { title: "La Mer · Year of the Horse pop-up", pts: 33 },
                { title: "IU pop-up, Gangnam", pts: 30 },
                {
                  title: "Bumble and bumble · The Moment at Sundance",
                  pts: 30,
                },
              ],
              note: "The parent's busiest lane — thirty-two events this year, more than any beauty brand but Sephora — and the field's best is a store opening received at 73. The house's best event is MAC's Sephora launch, where seven in ten shoppers were new to the brand; Bumble and bumble's dot is a film premiere it did not stage and did not follow up. The parent's own events grade as well as Sephora's and are read at zero: an event with an ambassador in it is news for a day; an event with a crowd in it is a fandom.",
            },
            {
              id: "collab",
              label: "Two names on a box",
              sub: "collab",
              typical: 30,
              ceiling: 36,
              best: {
                brandName: "Sephora",
                title: "Sephora × Olive Young",
                pts: 40,
              },
              received: 30,
              own: [
                { title: "MAC × Basquiat", pts: 40 },
                { title: "Travel Retail × Stanley 1913", pts: 36 },
                { title: "Jo Malone · English Pear with the Jaggers", pts: 32 },
                { title: "Victoria Beckham, The NEW! Collection", pts: 28 },
              ],
              note: "The lane beauty plays least: ten collabs on the parent's shelf, three to five on everyone else's, the field's ceiling the lowest of the six lanes. MAC's Basquiat collection is the house's best two-name box and the parent's Stanley set the best of its own, received at 30. Not where the fandom is — and Dr.Jart+, whose last collab was a K-pop group three years ago, has nothing here.",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Your column is aesthetic innovation and nothing else — the only beauty brand on the board with not one play coded for fandom — while the youngest brand in the category runs seventeen of them and the highest scarcity fit in beauty.",
          title: "Which strategy each beauty brand plays",
          provenance: "measured",
          note: "The five beauty brands on the board against the five cultural strategies, from every play on their shelves this year: how much of each brand's record carries each strategy, on one scale across the grid. A cold cell in a hot column is a gap. Tap a cell for the read.",
          cols: [
            "Fandom",
            "Identity signal",
            "Aesthetic innovation",
            "Scarcity",
            "Opacity",
          ],
          rows: [
            {
              label: "Estée Lauder",
              cells: [
                {
                  v: 0,
                  note: "Zero. Eighty-four plays on the record and not one coded for fandom — the only empty fandom cell in beauty, and the column the question is about.",
                },
                {
                  v: 8,
                  note: "Two plays — the IU × ELLE Korea piece and one campaign. Your ambassadors are talent in marketing, not identity signals the crowd picks up.",
                },
                {
                  v: 100,
                  note: "Twenty-five plays, the hottest cell on the grid: reformulations, pop-ups, campaigns — the house plays beauty as craft, and the crowd reads craft quietly.",
                },
                {
                  v: 32,
                  note: "Eight plays — gift sets, a travel-retail exclusive, the Ageless Beauty event. Scarcity as a retailer's tactic, never a fandom's calendar.",
                },
                {
                  v: 4,
                  note: "One play. Nothing withheld, nothing to decode — everything the house does is announced.",
                },
              ],
            },
            {
              label: "Rhode",
              cells: [
                {
                  v: 68,
                  note: "Seventeen fandom plays — tour hoodies, terry bags, the lip case, Coachella, a waitlist initiation. A brand three years old with the deepest fandom record in beauty.",
                },
                {
                  v: 32,
                  note: "Eight plays: the founder's face and the peptide-glaze look the crowd adopted as an identity.",
                },
                {
                  v: 64,
                  note: "Sixteen plays — the case, the packaging, the pop-up stations. Aesthetic innovation in service of a crowd, not instead of one.",
                },
                {
                  v: 60,
                  note: "Fifteen plays and the highest fit in beauty: mystery drops, waitlists, city-edition hoodies. The sellout is the strategy.",
                },
                {
                  v: 48,
                  note: "Twelve plays — mystery drops and unannounced restocks. The crowd is kept guessing on purpose.",
                },
              ],
            },
            {
              label: "Sephora",
              cells: [
                {
                  v: 12,
                  note: "Three plays — the Edinburgh opening received at 73, Quiet Hours, the advent calendar waitlist. Few, and the best received in the category.",
                },
                {
                  v: 56,
                  note: "Fourteen plays: the retailer as an identity — Summer Club, Quiet Hours, the K-beauty edit.",
                },
                {
                  v: 84,
                  note: "Twenty-one plays — store launches, SEPHORiA, the Olive Young edit.",
                },
                {
                  v: 28,
                  note: "Seven plays — the advent calendar, exclusive launches.",
                },
                {
                  v: 24,
                  note: "Six plays — the mystery of an edit, the reveal of a partner.",
                },
              ],
            },
            {
              label: "Aesop",
              cells: [
                {
                  v: 12,
                  note: "Three plays — the Aposē lamp, the Queer Library received at 67, a design collab. Aesop's crowd is a design crowd; fandom is the word it would never use.",
                },
                {
                  v: 80,
                  note: "Twenty plays: the store as a signal, the Queer Library, the conversations on architecture. The clearest identity in beauty.",
                },
                {
                  v: 96,
                  note: "Twenty-four plays — the Factory of Light, the strongest play in the category this year.",
                },
                {
                  v: 24,
                  note: "Six plays — the lamp's run, the Milan installation's week.",
                },
                {
                  v: 24,
                  note: "Six plays — a house that explains little and lets the room speak.",
                },
              ],
            },
            {
              label: "OUAI",
              cells: [
                {
                  v: 8,
                  note: "Two plays — soap dispensers and the Bond Repair pop-up. Small, but OUAI's shelf says 'bring back', 'cult' and 'TikTok' more than any beauty brand but Rhode.",
                },
                {
                  v: 0,
                  note: "None coded. The founder's voice carries the brand and the record does not tag it.",
                },
                {
                  v: 48,
                  note: "Twelve plays — the scents, the hair gloss, the reissues.",
                },
                {
                  v: 8,
                  note: "Two plays — the Palo Santo leave-in, the gloss exclusive.",
                },
                {
                  v: 8,
                  note: "Two plays.",
                },
              ],
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The beauty board's two biggest climbs this year were fandom-led and reissue-led — Rhode's drops and OUAI's comebacks — while yours came from ambassadors and pop-ups and is the slowest of the three; the trend in the category is the crowd, and the house is not in it.",
          title: "Where the beauty board moved",
          provenance: "measured",
          note: "The five beauty brands on the board since the spring — where each stands, how far it moved and what the record says carried it — then three category numbers read as signals. Sparklines are the served score by window.",
          rows: [
            {
              label: "Rhode",
              context:
                "board #28 · seventeen fandom plays, eighteen merch drops, the highest scarcity fit in beauty",
              value: "57.7",
              delta: 16.3,
              spark: [41.4, 39.8, 43.3, 47.3, 51.4, 51.9, 50.7, 54.7, 57.7],
            },
            {
              label: "OUAI",
              context:
                "board #35 · reissues and 'bring back' — the Shibuya body crème returned because its fans asked",
              value: "44.7",
              delta: 14.0,
              spark: [30.7, 32.1, 34.9, 38.5, 39.3, 42.1, 43.9, 44.7],
            },
            {
              label: "Sephora",
              context:
                "board #30 · store launches and Summer Club; the best-received community plays in the category",
              value: "54.4",
              delta: 11.5,
              spark: [42.9, 44.0, 48.4, 50.9, 50.6, 50.9, 51.3, 54.4],
            },
            {
              label: "Estée Lauder",
              context:
                "board #34 · ambassadors, reformulations and pop-ups; zero fandom-coded plays",
              value: "50.5",
              delta: 7.1,
              spark: [
                43.4, 43.1, 43.4, 46.2, 47.8, 48.6, 47.1, 46.9, 48.2, 48.2,
                49.9, 51.1, 50.5,
              ],
            },
            {
              label: "Aesop",
              context:
                "board #31 · design rooms and the Queer Library; peaked in July and cooled — no fan language anywhere on its record",
              value: "53.4",
              delta: -4.3,
              spark: [44.4, 48.8, 51.6, 54.0, 52.9, 57.3, 57.7, 55.3, 53.4],
            },
            {
              label: "Fandom plays across beauty",
              context:
                "twenty-five on the whole category's record; seventeen of them Rhode's, none yours",
              value: "25",
            },
            {
              label: "Fan language on the record",
              context:
                "rows that say viral, fan, restock, sold out, bring back — Rhode 20 of 63, OUAI 14 of 54, yours 6 of 84",
              value: "1 in 14",
            },
            {
              label: "Ceiling of a beauty play",
              context:
                "no beauty play graded above the mid-fifties this year against the board's crowd-shot ceiling in the high eighties — the category's fandom is early",
              value: "53",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The early signals inside the house all point the same way — the crowd is already doing the launch work for the brands you left alone, and the one number the parent should envy is MAC's: seven in ten launch shoppers new to the brand, on the year the house spent on it.",
          title: "Early signals from the acquired brands",
          provenance: "observed",
          note: "Eight public numbers from the acquired brands over the last two quarters, read as signals rather than results. Sparklines are the last six readings where a series exists.",
          rows: [
            {
              label: "Too Faced · the Chocolate Bar",
              context:
                "petitions and 'why did they stop' videos; the palette at a premium on eBay since the discontinuation",
              value: "premium",
              spark: [1, 1.4, 1.9, 2.3, 2.8, 3.2],
            },
            {
              label: "Dr.Jart+ · Cicapair on camera",
              context:
                "repurchase videos in three languages; the last global campaign October 2023 — three years silent",
              value: "3 yrs silent",
              spark: [30, 38, 44, 52, 61, 70],
            },
            {
              label: "Aveda · 'smells like Shampure'",
              context:
                "a TikTok genre — home recipes and diffuser dupes for a scent thirty-five years old, never sold as one",
              value: "35 years",
              spark: [20, 24, 31, 40, 52, 66],
            },
            {
              label: "MAC · new to the brand at Sephora",
              context:
                "share of launch shoppers new to MAC in March; number five makeup brand at Sephora at Kohl's in month one",
              value: "73% new",
            },
            {
              label: "Clinique · Black Honey",
              context:
                "past a billion views, 'seven sold a minute'; lipliner, nail polish, pop-up and a creator campaign inside two years",
              value: "1B+ views",
              spark: [10, 25, 48, 70, 88, 100],
            },
            {
              label: "Le Labo · the Costco restock",
              context:
                "Santal 33 at roughly half price, 'when will Costco restock' cycles on TikTok; city exclusives every September",
              value: "half price",
              spark: [40, 70, 35, 80, 45, 90],
            },
            {
              label: "Tom Ford · the Lost Cherry dupe economy",
              context:
                "forty-dollar copies of a two-hundred-and-forty-dollar bottle; a billion-dollar brand a year after the write-down",
              value: "6× cheaper",
              spark: [50, 58, 66, 74, 82, 90],
            },
            {
              label: "Bumble and bumble · after The Moment",
              context:
                "Sundance in January, a Bb collaborator's hair in every frame; the follow-up an 850-store wholesale deal",
              value: "1 film, 0 plays",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Every brand you feed sits on the floor of the map, and every brand you tried to sell this year sits in the top-right corner — the crowd did not leave when the money did, it is still petitioning, duping and copying what you own.",
          title: "Fandom against what the parent spent",
          provenance: "projected",
          x: {
            label: "Fandom",
            low: "quiet",
            high: "loud",
            hint: "what the crowd makes, trades and argues about on its own — dupes, petitions, hacks, resale",
          },
          y: {
            label: "Left unspent",
            low: "spent",
            high: "unspent",
            hint: "how little the parent put behind the brand in the last two years — ambassadors, launches, doors; a sale attempt counts against it",
          },
          quadrants: {
            tr: "Untapped",
            tl: "Nothing to tap",
            br: "Working",
            bl: "Quiet and tended",
          },
          note: "Every brand the house owns. Across is the crowd's own volume — dupes and decants, comeback petitions, hacks, nostalgia, the connoisseur trade. Up is how little the parent spent on it in two years — ambassadors, launches, campaigns, doors; a sale attempt, an impairment or a closed headquarters pushes a brand up. Dot size is the brand's weight in the house; grey dots are the brands you founded. Tap a dot for the read.",
          points: [
            {
              id: "too-faced",
              label: "Too Faced",
              short: "Too Faced",
              era: "Acquired",
              color: "#FB923C",
              x: 74,
              y: 86,
              w: 40,
              status: "recommended",
              note: "The Chocolate Bar palette is petitioned back on every platform and trades at a premium on eBay; Better Than Sex is still the mascara a category is measured against. The parent's year: a write-down, a sale that found no buyer at the price, the Irvine headquarters closed, 67 roles gone by December, the brand folded into the MAC cluster. The loudest crowd in the house with the least behind it.",
            },
            {
              id: "dr-jart",
              label: "Dr.Jart+",
              short: "Dr.Jart+",
              era: "Acquired",
              color: "#FB923C",
              x: 70,
              y: 84,
              w: 30,
              status: "recommended",
              note: "Cicapair's green colour corrector is a viral redness fix in every market — creators repurchase it on camera in French, Romanian and English, and this spring they discussed the brand being put up for sale in the same videos. The last global push was Enhypen in October 2023; since then a $375M impairment, a sale explored, a leaner Korea team and not one mention on the FY26 call.",
            },
            {
              id: "aveda",
              label: "Aveda",
              short: "Aveda",
              era: "Acquired",
              color: "#FB923C",
              x: 62,
              y: 72,
              w: 44,
              status: "recommended",
              note: "'Perfume that smells like Shampure' is a TikTok genre — home recipes, diffuser dupes, a thirty-five-year-old scent people try to bottle because you never did. The parent's year: doors exited, some of its own stores closed, promotions rebalanced, the salon channel 'challenged'. A fandom for a smell, held by a hair company.",
            },
            {
              id: "bumble",
              label: "Bumble and bumble",
              era: "Acquired",
              color: "#FB923C",
              x: 58,
              y: 76,
              w: 26,
              note: "Hairdresser's Invisible Oil is the bestseller on hairtok, Surf Spray a cult, and in January Charli XCX's film The Moment arrived at Sundance with a Bb collaborator's hair in every frame. The follow-up was a wholesale distribution deal. A cultural moment handed to a brand that answered with a trade press release.",
            },
            {
              id: "smashbox",
              label: "Smashbox",
              era: "Acquired",
              color: "#FB923C",
              x: 50,
              y: 80,
              w: 18,
              note: "The original Photo Finish primer is a cult with NYX and Maybelline dupes named after it. The parent's answer in 2026: a Canada-only relaunch, a sale attempt, a 'significantly streamlined' Los Angeles team. Smaller crowd than Too Faced's, same silence.",
            },
            {
              id: "malle",
              label: "Frédéric Malle",
              era: "Acquired",
              color: "#FB923C",
              x: 44,
              y: 78,
              w: 12,
              note: "Portrait of a Lady entered the Fragrance Foundation's Hall of Fame this year; the connoisseur base rates the pre-acquisition editions higher and says so at length. The founder left in June 2024, there is no ambassador, and management has not said the name in a year. Small, devoted, unaddressed.",
            },
            {
              id: "bobbi-brown",
              label: "Bobbi Brown",
              era: "Acquired",
              color: "#FB923C",
              x: 48,
              y: 60,
              w: 34,
              note: "A loyalist base that complains about every discontinuation and drifts to the founder's Jones Road for the philosophy it bought here. One reformulation in twenty years, in July, with an ambassador; lip and eye still declining. A fandom leaking to its own founder.",
            },
            {
              id: "origins",
              label: "Origins",
              era: "Founded in-house",
              color: "#94A3B8",
              x: 36,
              y: 70,
              w: 28,
              note: "Mega-Mushroom nostalgia and a counterfeit market — 'real versus fake' searches are the fandom's tell. Amazon in May 2025, then parked under DECIEM's digital-first model in August with no campaign yet. Quiet, and waiting.",
            },
            {
              id: "the-ordinary",
              label: "The Ordinary",
              era: "Acquired",
              color: "#FB923C",
              x: 92,
              y: 22,
              w: 60,
              status: "current",
              note: "The one portfolio play your index actually measured: the PDRN pop-up in April, read seven times through August. A TikTok Shop brand whose fans' glycolic-on-scalp hack became a commissioned clinical study — the crowd writes the roadmap and the brand ships it. The model for the rest of the house, and already spent.",
            },
            {
              id: "clinique",
              label: "Clinique",
              era: "Founded in-house",
              color: "#94A3B8",
              x: 84,
              y: 18,
              w: 80,
              note: "Black Honey past a billion views, 'seven sold a minute', a lipliner, a nail polish, a pop-up and the house's first creator-led campaign in March. The fandom was found on TikTok and the parent built a franchise on it within two years — the tended case, in-house.",
            },
            {
              id: "mac",
              label: "MAC",
              era: "Acquired",
              color: "#FB923C",
              x: 88,
              y: 12,
              w: 90,
              note: "The artistry crowd's brand: Ruby Woo, the nowstalgia lip liner, the backstage lore. Sephora US in March with Chappell Roan on Viva Glam and Basquiat this fall — the most spent-on brand in the house, and the number one prestige makeup brand in the country by the summer. Working.",
            },
            {
              id: "le-labo",
              label: "Le Labo",
              era: "Acquired",
              color: "#FB923C",
              x: 82,
              y: 20,
              w: 44,
              note: "Santal 33's Costco restock is a TikTok cycle of its own; the city exclusives are a September pilgrimage. Violette 30, Shiu 25 in Beijing, new stores — the fandom and the parent are in step, and it led fragrance growth this year.",
            },
            {
              id: "tom-ford",
              label: "Tom Ford Beauty",
              era: "Acquired",
              color: "#FB923C",
              x: 78,
              y: 24,
              w: 56,
              note: "Lost Cherry has a dupe economy — $40 copies of a $240 bottle — and the Private Blend re-releases answered collector demand. Figue Érotique, Oud Voyager, the fall quads: a billion-dollar brand a year after a $549M write-down. Spent, and paying.",
            },
            {
              id: "jo-malone",
              label: "Jo Malone London",
              era: "Acquired",
              color: "#FB923C",
              x: 66,
              y: 16,
              w: 60,
              note: "Wood Sage & Sea Salt is duped by Zara with the founder herself in the room. Two ambassador campaigns this year, a scent-layering filter for the under-thirties, an AI advisor, thirty-three new fragrance doors with Le Labo — crossed a billion. Tended.",
            },
            {
              id: "kilian",
              label: "Kilian Paris",
              era: "Acquired",
              color: "#FB923C",
              x: 60,
              y: 26,
              w: 24,
              note: "Angels' Share and Love, Don't Be Shy are perfumetok staples with Rihanna lore attached; the Cocktail Collection went to Sephora in August at ten millilitres for $37. Thirty-two boutiques from three at acquisition — the CEO's model single-brand deal.",
            },
            {
              id: "la-mer",
              label: "La Mer",
              era: "Acquired",
              color: "#94A3B8",
              x: 56,
              y: 20,
              w: 70,
              note: "The 'Nivea is La Mer' discourse is the dupe culture of a two-thousand-dollar cream. Jay Chou as the first male face, the Year of the Horse pop-up across Asia, a new eye cream — spent heavily, in the markets that matter for it.",
            },
            {
              id: "estee-lauder",
              label: "Estée Lauder",
              era: "Founded in-house",
              color: "#94A3B8",
              x: 52,
              y: 10,
              w: 100,
              note: "Your measured record: Double Wear reformulated for the first time since 1997 with Daisy Edgar-Jones, Nia Long, IU and Zhu Yilong, Glimmer with Hailee Steinfeld, a pop-up in every capital. Institutions rather than fandoms — nobody dupes Advanced Night Repair on camera — and the most spent-on name in the house.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The gap is not that the crowds are small — Too Faced's is louder than Jo Malone's — it is that the parent's spend runs the wrong way: the brands with the most unsolicited fandom got a sale process, the ones with the least got an ambassador.",
          title: "What the crowd makes, what the parent spends",
          provenance: "projected",
          mode: "pair",
          a: { label: "Fandom", color: "#FB923C" },
          b: { label: "Parent's activation", color: "#94A3B8" },
          note: "Two measures on a 0 to 100 scale, brand by brand: the crowd's own volume — dupes, petitions, hacks, resale, the nostalgia genre — against what the parent put behind the brand in the last two years. The tail is the public fact each brand is known by this year. Tap a row for the read.",
          rows: [
            {
              id: "too-faced",
              label: "Too Faced",
              sub: "acquired 2016 · makeup",
              a: 74,
              b: 14,
              tail: "petitioned",
              tailLow: true,
              note: "The palette people petition for and pay a premium to find, against a year of write-down, sale attempt and a closed headquarters. The largest gap in the house.",
            },
            {
              id: "dr-jart",
              label: "Dr.Jart+",
              sub: "acquired 2019 · skincare",
              a: 70,
              b: 16,
              tail: "Oct 2023",
              tailLow: true,
              note: "The green tube is repurchased on camera in three languages; the last global campaign is three years old. The crowd kept the brand alive through a sale process it watched in real time.",
            },
            {
              id: "aveda",
              label: "Aveda",
              sub: "acquired 1997 · hair",
              a: 62,
              b: 28,
              tail: "35 years",
              tailLow: true,
              note: "A scent the internet tries to make at home, sold only as shampoo. The activation that exists is a salon strategy and an Amazon listing; the fandom is for the smell.",
            },
            {
              id: "bumble",
              label: "Bumble and bumble",
              sub: "acquired 2006 · hair",
              a: 58,
              b: 24,
              tail: "Sundance",
              tailLow: true,
              note: "A film at Sundance with the brand's hair in it, then a wholesale deal. The moment was cultural; the reply was trade.",
            },
            {
              id: "smashbox",
              label: "Smashbox",
              sub: "acquired 2010 · makeup",
              a: 50,
              b: 20,
              tail: "Canada only",
              tailLow: true,
              note: "The primer with dupes named after it got its relaunch in one country, with SPF, while the team shrank.",
            },
            {
              id: "malle",
              label: "Frédéric Malle",
              sub: "acquired 2014 · fragrance",
              a: 44,
              b: 22,
              tail: "Hall of Fame",
              tailLow: true,
              note: "A Hall of Fame scent and a founderless house. The connoisseurs are still talking; nobody from the parent is in the conversation.",
            },
            {
              id: "bobbi-brown",
              label: "Bobbi Brown",
              sub: "acquired 1995 · makeup",
              a: 48,
              b: 40,
              tail: "Jones Road",
              tailLow: true,
              note: "One reformulation and one ambassador this year against a loyalist base that follows the founder to her new brand. The gap is smaller than it looks because the crowd is leaving.",
            },
            {
              id: "the-ordinary",
              label: "The Ordinary",
              sub: "acquired 2021 · skincare",
              a: 92,
              b: 78,
              tail: "measured",
              note: "The fans' scalp hack became a clinical study, the body line went to TikTok Shop, and the brand now incubates Origins. The one sub-brand your index measured, and the one where the parent spends at the crowd's pace.",
            },
            {
              id: "clinique",
              label: "Clinique",
              sub: "founded 1968 · skincare",
              a: 84,
              b: 82,
              tail: "Black Honey",
              note: "A billion views turned into a franchise — lipliner, nail polish, pop-up, a creator-led campaign — inside two years. The house knows how to do this; it did it in-house.",
            },
            {
              id: "mac",
              label: "MAC",
              sub: "acquired 1998 · makeup",
              a: 88,
              b: 88,
              tail: "#1 prestige",
              note: "Sephora, Chappell Roan, Basquiat. The most spent-on acquisition and the one crowned number one prestige makeup brand by the summer. Fandom and spend in step.",
            },
            {
              id: "le-labo",
              label: "Le Labo",
              sub: "acquired 2014 · fragrance",
              a: 82,
              b: 80,
              tail: "Violette 30",
              note: "Restock cycles, city exclusives and new stores. The fandom is a pilgrimage and the parent builds the shrines.",
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "The three untapped fandoms are three different kinds — a palette people want back, a product people vouch for on camera, a smell people try to copy — so one playbook will not serve them; the tended brands show which play answers which crowd.",
          title: "What kind of fandom each brand holds",
          provenance: "projected",
          note: "Each brand's crowd sorted by what it does on its own — asks for a discontinued thing back, vouches for a product and hacks it, tries to copy or bottle a feeling, or trades and argues as connoisseurs. Every row is one whole. Tap a row for the read.",
          legend: [
            { key: "comeback", label: "Comeback demand", color: "#FF5A76" },
            { key: "hack", label: "Vouch & hack", color: "#60A5FA" },
            { key: "copy", label: "Copy & nostalgia", color: "#FDE047" },
            { key: "trade", label: "Connoisseur trade", color: "#B388FF" },
          ],
          rows: [
            {
              id: "too-faced",
              label: "Too Faced",
              sub: "a palette people want back",
              parts: [
                { key: "comeback", v: 62 },
                { key: "hack", v: 18 },
                { key: "copy", v: 14 },
                { key: "trade", v: 6 },
              ],
              note: "Two thirds of the crowd is asking for the Chocolate Bar back — petitions, resale, 'why did they stop making it'. Comeback demand is the easiest fandom to serve: the product already exists, the date is the play.",
            },
            {
              id: "dr-jart",
              label: "Dr.Jart+",
              sub: "a product people vouch for",
              parts: [
                { key: "comeback", v: 6 },
                { key: "hack", v: 70 },
                { key: "copy", v: 16 },
                { key: "trade", v: 8 },
              ],
              note: "Seven in ten are vouching: repurchase videos, before-and-afters, the green tube under foundation. This crowd wants to be the campaign — The Ordinary's fans were, and the brand doubled its shelf.",
            },
            {
              id: "aveda",
              label: "Aveda",
              sub: "a smell people try to copy",
              parts: [
                { key: "comeback", v: 8 },
                { key: "hack", v: 12 },
                { key: "copy", v: 68 },
                { key: "trade", v: 12 },
              ],
              note: "Two thirds are copying: recipes, diffuser blends, 'perfume that smells like Shampure'. When a crowd tries to bottle a feeling you own, the play is to bottle it first.",
            },
            {
              id: "bumble",
              label: "Bumble and bumble",
              sub: "a look people borrow",
              parts: [
                { key: "comeback", v: 10 },
                { key: "hack", v: 48 },
                { key: "copy", v: 34 },
                { key: "trade", v: 8 },
              ],
              note: "Half vouch for the oil, a third borrow the film's hair. A crowd made by a cultural moment wants the next one, not a distributor.",
            },
            {
              id: "malle",
              label: "Frédéric Malle",
              sub: "editions people argue over",
              parts: [
                { key: "comeback", v: 22 },
                { key: "hack", v: 4 },
                { key: "copy", v: 8 },
                { key: "trade", v: 66 },
              ],
              note: "Two thirds trade and argue — which edition, which year, before or after the founder. A connoisseur crowd is served by disclosure and numbered editions, never by an ambassador.",
            },
            {
              id: "the-ordinary",
              label: "The Ordinary",
              sub: "the tended case",
              parts: [
                { key: "comeback", v: 4 },
                { key: "hack", v: 74 },
                { key: "copy", v: 10 },
                { key: "trade", v: 12 },
              ],
              note: "The same shape as Dr.Jart+'s crowd — vouching and hacking — and the parent let the crowd write the roadmap. That is the precedent for the green tube, already inside the house.",
            },
            {
              id: "clinique",
              label: "Clinique",
              sub: "the tended case, in-house",
              parts: [
                { key: "comeback", v: 30 },
                { key: "hack", v: 34 },
                { key: "copy", v: 30 },
                { key: "trade", v: 6 },
              ],
              note: "Black Honey was comeback demand for a 1971 shade, hack culture and nostalgia at once — and the house served all three in two years. The Too Faced crowd is the same shape with a palette instead of a lipstick.",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves for three kinds of crowd, none of them a campaign: a dated return for the palette, the fans' own camera for the green tube, a bottle for the smell — priced together at a little over two and a half points on the parent.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "The Chocolate Bar comes back on a date — numbered, the original formula disclosed, the holiday window, with the petition's own signatories first in line",
              itemType: "archive_reissue",
              window:
                "Announced in October, on sale the week before Thanksgiving; a second numbered run for the spring if the first sells through",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "scarcity", fit: 0.7 },
                { code: "identity_signal", fit: 0.4 },
              ],
              why: "Comeback demand is the cheapest fandom to answer because the product exists and the crowd has already done the marketing — the petitions, the resale premiums, the 'why did they stop' videos are the launch campaign. Clinique proved the house can turn a revived shade into a franchise in two years; the Chocolate Bar is a palette instead of a lipstick, with a crowd that never stopped asking. Numbered and dated, it turns the petition into a queue and the queue into a reason to keep the brand you almost sold.",
              effect: {
                label: "CIQ",
                delta: 1.1,
                series: [0, 0.4, 0.7, 0.95, 1.1],
              },
              precedents: 3,
              reception:
                "beauty's comebacks this year are graded 34 to 38 and read as cult returns; the board's best return is a 71",
              similar: [
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: "Marc Jacobs Beauty Global Relaunch",
                  pts: 37.6,
                },
                {
                  brand: "ouai",
                  brandName: "OUAI",
                  title: "Body Crème Shibuya Reissue",
                  pts: 34.0,
                },
                {
                  brand: "ferrari",
                  brandName: "Ferrari",
                  title: "Ferrari 250 GTO restoration honoured at Villa d'Este",
                  pts: 71.4,
                },
              ],
            },
            {
              name: "Cicapair on the fans' own camera — the creators who kept the green tube alive through the sale become its faces, TikTok Shop first, a standing Redness Council that gets the next formula before the press does",
              itemType: "content",
              window:
                "From January, when the winter redness season starts; the council seated by March, the first crowd-written launch in the spring",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.6 },
                { code: "opacity", fit: 0.3 },
              ],
              why: "A vouching crowd wants to be the campaign, not to watch one. The Ordinary's fans wrote a hack, the brand ran a clinical study on it and shipped the result — that precedent is already inside the house and it is the second-largest skincare brand in the country. Dr.Jart+ has the same crowd shape around one product and has not had a global face since 2023; the faces are already posting. The cost is a seat at the table, not an ambassador fee.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.25, 0.5, 0.7, 0.8],
              },
              precedents: 3,
              reception:
                "beauty's crowd-carried plays are graded 29 to 39 and say 'viral' on the record; the board's crowd-shot ceiling is an 88",
              similar: [
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title: "Summer Station Snap-On Lip Cases (Minori)",
                  pts: 38.5,
                },
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: '"Mario\'s Beauty Booth" TikTok series',
                  pts: 29.4,
                },
                {
                  brand: "apple",
                  brandName: "Apple",
                  title: '"Shot on iPhone" Campaign (Ongoing Activity)',
                  pts: 88.4,
                },
              ],
            },
            {
              name: "Shampure, bottled — the scent the internet is trying to copy sold as a fragrance and a home scent, in the salon chair first and online a month later, the thirty-five-year story told straight",
              itemType: "capsule",
              window:
                "A limited first run in February, the permanent line by the summer; the salon gets it a month before anyone else",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "aesthetic_innovation", fit: 0.5 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "When a crowd tries to bottle a feeling you own, bottle it first. The genre exists without you — recipes, diffuser dupes, 'what perfume smells like the Aveda salon' — and fragrance is the house's fastest-growing category, up a tenth this year, with thirty-three new fragrance doors opened for Le Labo and Jo Malone. Aveda's fandom is for a smell, and the parent has been selling it shampoo. A scarce first run through the salon gives the channel the strategy says is the centre a reason to be one.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.2, 0.4, 0.6, 0.7],
              },
              precedents: 3,
              reception:
                "beauty's scarce drops are received at 40 to 53 when the crowd is already waiting; your own fragrance launches read 47 to 73 where they were read at all",
              similar: [
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title:
                    "Met Gala Mystery Drop (Pocket Bronze, Highlight Milk)",
                  pts: 33.5,
                },
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title: "Summer 2026 Limited Edition Waitlist Initiation",
                  pts: 32.8,
                },
                {
                  brand: "ouai",
                  brandName: "OUAI",
                  title: "Limited-Edition Palo Santo Leave-In",
                  pts: 33.3,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the parent's measured record and the public facts in the file header, and compound with your current course, not on top of it. Every sub-brand figure is modelled from public evidence; the parent's 50.5 and The Ordinary's pop-up are the measured anchors.",
        },
        {
          kind: "trendCompare",
          insight:
            "The three moves are worth about three times what today's course collects from the same brands by next September — and the difference arrives in the first two months, because the crowds are already assembled.",
          title: "What the three fandoms return, cumulative",
          provenance: "projected",
          note: "Incremental net sales from Too Faced, Dr.Jart+ and Aveda, in millions of dollars, added up from October: with the three moves; and on today's course — the streamlined teams, the salon strategy, no dated return. The shaded month is the Chocolate Bar's return.",
          highlight: {
            from: "2026-11-01",
            to: "2026-11-30",
            label: "the Chocolate Bar returns",
          },
          series: [
            {
              key: "plan",
              label: "The return, the camera, the bottle",
              color: "#FB923C",
              points: [
                { d: "2026-10-01", v: 0 },
                { d: "2026-11-01", v: 18 },
                { d: "2026-12-01", v: 34 },
                { d: "2027-01-01", v: 40 },
                { d: "2027-02-01", v: 52 },
                { d: "2027-03-01", v: 60 },
                { d: "2027-04-01", v: 70 },
                { d: "2027-05-01", v: 78 },
                { d: "2027-06-01", v: 86 },
                { d: "2027-07-01", v: 92 },
                { d: "2027-08-01", v: 100 },
                { d: "2027-09-01", v: 108 },
              ],
            },
            {
              key: "base",
              label: "Today's course",
              color: "#94A3B8",
              ghost: true,
              points: [
                { d: "2026-10-01", v: 0 },
                { d: "2026-11-01", v: 4 },
                { d: "2026-12-01", v: 9 },
                { d: "2027-01-01", v: 11 },
                { d: "2027-02-01", v: 14 },
                { d: "2027-03-01", v: 17 },
                { d: "2027-04-01", v: 20 },
                { d: "2027-05-01", v: 23 },
                { d: "2027-06-01", v: 26 },
                { d: "2027-07-01", v: 28 },
                { d: "2027-08-01", v: 31 },
                { d: "2027-09-01", v: 34 },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.6,
          body: "About two and a half points on your published score, from 50.5 to roughly 53, on three brands the house already owns and nearly sold. In money it is on the order of a hundred million dollars of incremental sales by next September, most of it in the first two quarters, because none of the three crowds has to be built — they are petitioning, posting and copying today. Unlike an ambassador's season, a fandom answered stays: the palette's buyers, the council's creators and the salon's scent are all yours the year after.",
        },
        {
          kind: "modelView",
          body: "The beauty board is being climbed by the crowd. The youngest brand in the category sits several places above you on a record made of hoodies, waitlists and mystery drops; the smallest one is climbing on products its fans asked to have back; the retailer's best-received plays are a store opening and a quiet hour. Your own climb is real and it is the slowest of the three — ambassadors, reformulations and pop-ups, graded as craft and read quietly — and yours is the only shelf in beauty with no play coded for fandom at all. The category's ceiling is still low, which is the opportunity: nobody in beauty has played fandom at the scale this house could.\n\nAnd the house knows how. It found a fifty-year-old lipstick shade on a feed and made a franchise of it in two years; it let a skincare crowd write a clinical study and shipped the result; it put its artistry brand in front of a new generation and took the top of the category. Every one of those brands sits on the floor of the map, fandom and spend in step.\n\nThe brands in the top corner are the ones the house tried to sell this year. That is not a coincidence — a sale process is the loudest possible statement that a parent has nothing planned, and the crowds heard it and kept going anyway: petitioning for a palette, vouching for a green tube, trying to bottle a smell. Each is a different kind of fandom and each wants a different answer — a date, a camera, a bottle — none of which is a campaign. The opportunity is not to invent a crowd for these brands. It is to stop leaving the ones they have on the table.",
        },
      ],
    },
    {
      id: "fragrance-vs-makeup",
      // the drop and the restock cycle — the format the growing category runs on
      itemType: "capsule",
      type: "momentum",
      question: "Why is fragrance up while makeup is flat?",
      aliases: [
        "why is fragrance gaining momentum while makeup is flat",
        "why is fragrance growing while makeup is flat",
        "why is fragrance growing and makeup flat",
        "why is fragrance up and makeup flat",
        "why is makeup flat while fragrance grows",
        "why is makeup flat",
        "why is fragrance gaining momentum",
        "fragrance vs makeup",
        "fragrance versus makeup",
        "what is driving fragrance growth",
      ],
      askedOn: "2026-09-25",
      blocks: [
        {
          kind: "readout",
          provenance: "observed",
          verdict:
            "Fragrance grows on the price of a bottle and a crowd that is new; makeup has no new crowd, and its buyers are leaving for skin.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The house is the market with the volume turned up: fragrance grows everywhere on price and new buyers, makeup grows nowhere on units. Where your makeup grew it was one relaunch and one brand made cool again.",
          items: [
            {
              label: "Fragrance, the house",
              value: "+10%",
              hint: "the year's organic growth, in every region, led by Le Labo, Tom Ford and Kilian — a third the size of makeup and carrying the growth",
            },
            {
              label: "Makeup, the house",
              value: "flat",
              hint: "the year's organic growth — MAC and Double Wear up, Bobbi Brown and Too Faced down; the average of a growing top and a shrinking middle",
            },
            {
              label: "Prestige fragrance, US",
              value: "+6%",
              hint: "the first half of the year in dollars, with units flat and the average bottle five percent dearer",
            },
            {
              label: "Prestige makeup, US",
              value: "+3%",
              hint: "the first half in dollars, units softening; lip liner, blush and bronzer the only pockets growing fast",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Every category is growing on price, not on things sold — except mass fragrance, where a new crowd is buying more bottles. That crowd trades up over years, and the house owns the top of the ladder it climbs.",
          title: "Dollars against units, by category",
          provenance: "observed",
          mode: "pair",
          a: { label: "Dollars", color: "#FB923C" },
          b: { label: "Units", color: "#94A3B8" },
          note: "Growth in the first half of the year in the US, in percent: what each category took in dollars against how many more things it sold. The tail is the number that explains the gap. Tap a row for the read.",
          rows: [
            {
              id: "prestige-fragrance",
              label: "Prestige fragrance",
              sub: "first half of the year, US",
              a: 6,
              b: 0,
              tail: "bottle +5%",
              note: "All of the growth is the price of a bottle: units flat, eau de parfum and parfum growing double digits while the lighter concentrations do not. A category trading up — which is where the house's luxury scents live.",
            },
            {
              id: "mass-fragrance",
              label: "Mass fragrance",
              sub: "the fastest-growing mass category",
              a: 15,
              b: 7,
              tail: "mists",
              note: "The only row here growing on units: body mists and minis, the door a fifteen-year-old walks through. Nobody in the house sells the bottom rung — Kilian's ten-millilitre cocktails at Sephora are the closest thing you own.",
            },
            {
              id: "prestige-makeup",
              label: "Prestige makeup",
              sub: "lip liner, blush and bronzer growing; the rest flat",
              a: 3,
              b: 0,
              tail: "units softening",
              tailLow: true,
              note: "Dollars up a little on price, units down: the buyers are not being replaced. The growth inside it is three small pockets — lip liner, blush, bronzer — and the decline is foundation, where Clinique lost double digits in the spring.",
            },
            {
              id: "mass-makeup",
              label: "Mass makeup",
              sub: "the same shape a tier down",
              a: 5,
              b: 0,
              tail: "units down",
              tailLow: true,
              note: "e.l.f. without Rhode grew about one percent last quarter. Makeup's excitement is on TikTok Shop under names that did not exist five years ago — and even they are growing on price.",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The fragrance crowd is young and climbing — a mist, then minis, then up. The makeup crowd is not being replaced; its money went to skin and three small pockets on the wall. Fragrance has a door for new buyers, makeup does not.",
          title: "What the crowd is doing",
          provenance: "observed",
          note: "Seven public numbers from the last year, read as signals rather than results. Sparklines are the last readings where a series exists.",
          rows: [
            {
              label: "Mists' share of fragrance units",
              context:
                "prestige, from seven percent three years ago — the entry bottle for Gen Z and the generation after it",
              value: "12%",
              spark: [7, 8, 9, 10, 11, 12],
            },
            {
              label: "Minis",
              context:
                "share of prestige fragrance units — decants, discovery sets, the ten-millilitre",
              value: "38% of units",
            },
            {
              label: "Fragrance spend from homes with a Gen Z member",
              context:
                "half a year to last summer; the cohort makeup never found",
              value: "38%",
            },
            {
              label: "Teenage boys' fragrance spend",
              context:
                "up in one year — the buyer prestige makeup does not have",
              value: "+44%",
              delta: 44,
              spark: [40, 48, 60, 72, 86, 100],
            },
            {
              label: "Lip liner",
              context:
                "the fastest-growing makeup segment, with blush and bronzer; the rest of the wall is flat",
              value: "+34%",
              delta: 34,
              spark: [50, 56, 62, 70, 84, 100],
            },
            {
              label: "Foundation",
              context:
                "Clinique's base lost double digits in the spring quarter; Korean base makeup on Tmall down by nearly half this August",
              value: "double digits down",
              spark: [100, 96, 90, 84, 70, 56],
            },
            {
              label: "Skin-makeup hybrids",
              context:
                "share of Gen Z and millennials who want makeup that is skincare — the base is leaving for the skin aisle, which grew nine percent",
              value: "6 in 10",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Growth follows what the product says about its owner, not its category: every growing name in the house is bought as a statement, every shrinking one is a utility with a cheaper copy. Fragrance is identity by nature; makeup only where a house makes it one.",
          title: "Growth follows identity, not category",
          provenance: "observed",
          x: {
            label: "What the product says",
            low: "a utility",
            high: "an identity",
            hint: "how much the thing is bought for who its owner is — a scent, an artistry brand, a status cream — against how much it is bought for what it does",
          },
          y: {
            label: "Momentum",
            low: "shrinking",
            high: "growing",
            hint: "the brand's own growth this year, from the house's results commentary and your measured record, on a 0 to 100 scale",
          },
          quadrants: {
            tr: "Identity, growing",
            tl: "Utility, growing",
            br: "Identity, unspent",
            bl: "Utility, shrinking",
          },
          note: "Every brand the house reports on, by category. Across is what the product says about the person holding it; up is how the brand moved this year. Dot size is the brand's weight in the house; the orange dots are the Estée Lauder brand's own three categories. Tap a dot for the read.",
          points: [
            {
              id: "le-labo",
              label: "Le Labo",
              era: "Fragrance",
              color: "#B388FF",
              x: 88,
              y: 90,
              w: 44,
              note: "Santal 33 is a signature people are recognised by; the city exclusives are a pilgrimage and the restock is a TikTok cycle. Led the house's fragrance growth this year, with new stores and Violette 30. Identity, sold scarce, growing.",
            },
            {
              id: "kilian",
              label: "Kilian Paris",
              era: "Fragrance",
              color: "#B388FF",
              x: 82,
              y: 88,
              w: 24,
              note: "Angels' Share and Love, Don't Be Shy are perfumetok staples; the Cocktail Collection went to Sephora in August at ten millilitres — the one bottom rung the house sells. One of the three fastest-growing brands in the house.",
            },
            {
              id: "tom-ford",
              label: "Tom Ford Beauty",
              era: "Fragrance",
              color: "#B388FF",
              x: 84,
              y: 84,
              w: 56,
              note: "Lost Cherry has a dupe economy, which is what an identity looks like from the outside. Figue Érotique, Oud Voyager and Soleil Neige carried the year; a billion-dollar brand a year after a write-down.",
            },
            {
              id: "jo-malone",
              label: "Jo Malone London",
              era: "Fragrance",
              color: "#B388FF",
              x: 74,
              y: 72,
              w: 60,
              note: "Layering is the brand's grammar — a scent you compose is a scent that says something about you. Crossed a billion this year, with thirty-three new fragrance doors shared with Le Labo.",
            },
            {
              id: "balmain",
              label: "Balmain Beauty",
              era: "Fragrance",
              color: "#B388FF",
              x: 70,
              y: 78,
              w: 10,
              note: "Two years old and named among the fragrance leaders in the spring quarter — a fashion house's name on a bottle is an identity before the juice is smelled.",
            },
            {
              id: "malle",
              label: "Frédéric Malle",
              era: "Fragrance",
              color: "#B388FF",
              x: 80,
              y: 48,
              w: 12,
              note: "The most identity per bottle in the house — Portrait of a Lady entered the Hall of Fame this year — and not named once in a year of results. Identity with nothing behind it does not grow on its own.",
            },
            {
              id: "aerin",
              label: "AERIN",
              era: "Fragrance",
              color: "#B388FF",
              x: 58,
              y: 44,
              w: 10,
              note: "A founder's taste sold as scent and never mentioned in the year's commentary. The fragrance category's tide did not lift it, because the tide lifts identities, not categories.",
            },
            {
              id: "mac",
              label: "MAC",
              era: "Makeup",
              color: "#FF5A76",
              x: 76,
              y: 68,
              w: 90,
              note: "The makeup exception that proves the rule: an artistry identity — Ruby Woo, the backstage lore, Chappell Roan on Viva Glam — taken to Sephora in March, lip share won on TikTok Shop, the number one prestige makeup brand in the country by summer. Makeup grows when it is an identity.",
            },
            {
              id: "clinique-makeup",
              label: "Clinique, makeup",
              era: "Makeup",
              color: "#FF5A76",
              x: 40,
              y: 30,
              w: 60,
              note: "Lost double digits in the spring quarter, and the results named the reason: the foundation subcategory. The one Clinique makeup that grew is Black Honey — a lipstick with a fandom, an identity inside a utility brand.",
            },
            {
              id: "bobbi-brown",
              label: "Bobbi Brown",
              era: "Makeup",
              color: "#FF5A76",
              x: 44,
              y: 24,
              w: 34,
              note: "Continued declines in lip and eye. A no-makeup philosophy is an identity, and this one moved to the founder's new brand; what stayed is the product, and the product is a utility.",
            },
            {
              id: "too-faced",
              label: "Too Faced",
              era: "Makeup",
              color: "#FF5A76",
              x: 52,
              y: 14,
              w: 40,
              note: "Retail softness, shop-in-shop doors closed, a sale that found no buyer at the price. The identity the crowd holds — the Chocolate Bar — is the one product the brand no longer makes.",
            },
            {
              id: "smashbox",
              label: "Smashbox",
              era: "Makeup",
              color: "#FF5A76",
              x: 36,
              y: 20,
              w: 18,
              note: "A primer — the purest utility on the wall — with cheaper copies named after it. A Canada-only relaunch and a smaller team.",
            },
            {
              id: "the-ordinary",
              label: "The Ordinary",
              era: "Skin care",
              color: "#4ADE80",
              x: 48,
              y: 92,
              w: 60,
              note: "A utility with a crowd: the fans write the roadmap, the brand ships it, the body line went to TikTok Shop. One of the three fastest-growing brands in the house — the utility quadrant grows where the crowd owns the product.",
            },
            {
              id: "la-mer",
              label: "La Mer",
              era: "Skin care",
              color: "#4ADE80",
              x: 62,
              y: 66,
              w: 70,
              note: "A cream bought as a status object — the Nivea dupe discourse is the tell — and a named skin-care driver all year, with Jay Chou and the Year of the Horse pop-up in the markets that matter for it.",
            },
            {
              id: "el-skin",
              label: "Estée Lauder, skin",
              era: "Estée Lauder, the brand",
              color: "#FB923C",
              x: 52,
              y: 70,
              w: 70,
              note: "Advanced Night Repair and Re-Nutriv carried the brand's year and the best-received thing on your measured shelf is the Re-Nutriv film, read at seventy-three. The buyer leaving foundation is arriving here.",
            },
            {
              id: "el-makeup",
              label: "Estée Lauder, makeup",
              era: "Estée Lauder, the brand",
              color: "#FB923C",
              x: 34,
              y: 56,
              w: 80,
              note: "Double Wear reformulated for the first time since 1997 and the brand's makeup grew double digits in the spring quarter — a relaunch's quarter for a utility's product. Eighteen plays on your record, two of them read. It sold, and it was not talked about.",
            },
            {
              id: "el-fragrance",
              label: "Estée Lauder, fragrance",
              short: "Glimmer",
              era: "Estée Lauder, the brand",
              color: "#FB923C",
              x: 78,
              y: 62,
              w: 30,
              status: "recommended",
              note: "Glimmer, the brand's first new scent in five years — a gourmand for the perfumetok crowd with Hailee Steinfeld — and already the best-read launch on your shelf: the teaser received at sixty. One size, one price, no ladder yet. This is the dot the moves are about.",
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "On your own shelf the crowd read fragrance and skin and ignored makeup: one bottle got three reads in four plays, one foundation got two in eighteen, three makeup collaborations got none. You spent more on makeup; a utility relaunched is trade news.",
          title: "How culture read your own shelf",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Your plays this year sorted by what they were about, on one scale. Bands are the beauty field's range for that kind of play — typical to ceiling; the ring is the field's strongest, the dots are yours. Received = the best presence the crowd gave any of them. Tap a lane for the read.",
          rows: [
            {
              id: "scent-launch",
              label: "A scent launch",
              sub: "Glimmer · content, capsule",
              typical: 27,
              ceiling: 40,
              best: {
                brandName: "Sephora",
                title: "Olive Young K-Beauty Edit launch",
                pts: 40,
              },
              received: 60,
              own: [
                { title: "Glimmer with Hailee Steinfeld", pts: 27 },
                { title: "Glimmer, announced", pts: 18 },
                { title: "Glimmer, limited quantities", pts: 18 },
              ],
              status: "recommended",
              note: "Four plays for one bottle and three of them were read — the teaser at sixty, the best-received launch on your shelf this year; the campaign a fortnight old and already the strongest episodic play you own. The first new scent in five years, and the crowd noticed in the first week.",
            },
            {
              id: "foundation",
              label: "A foundation relaunch",
              sub: "Double Wear · events, content",
              typical: 25,
              ceiling: 38,
              best: {
                brandName: "Sephora",
                title: "Edinburgh store launch",
                pts: 38,
              },
              received: 53,
              own: [
                { title: "A New Era campaign", pts: 24 },
                { title: "Flagship pop-up destination", pts: 22 },
                { title: "Heathrow service counter", pts: 20 },
              ],
              note: "Eighteen plays for one foundation — launch events, masterclasses, a sampling bus, pop-ups in five countries — and the crowd read two: the Heathrow counter at fifty-three and a campaign with as much criticism as praise. It sold double digits in the spring, and it was not talked about.",
            },
            {
              id: "makeup-collab",
              label: "A makeup collaboration",
              sub: "Victoria Beckham, Sabyasachi, Ladurée",
              typical: 30,
              ceiling: 36,
              best: {
                brandName: "Sephora",
                title: "Sephora × Olive Young",
                pts: 40,
              },
              own: [
                { title: "Ladurée lip oils", pts: 31 },
                { title: "Victoria Beckham collection", pts: 28 },
                { title: "Sabyasachi collection", pts: 25 },
              ],
              note: "Three names on your makeup this year and not one window in which the crowd mentioned any of them. Two names on a box is the lane beauty plays least, and on makeup it read as a shelf tag, not a moment.",
            },
            {
              id: "skin-story",
              label: "A skin story",
              sub: "Night Repair, Re-Nutriv",
              typical: 27,
              ceiling: 40,
              best: {
                brandName: "Aesop",
                title: "The Factory of Light, Milan Design Week",
                pts: 53,
              },
              received: 73,
              own: [
                { title: "Skin Longevity Institute", pts: 45 },
                { title: "Nia Long, The One", pts: 34 },
                { title: "Re-Nutriv, the paradigm", pts: 21 },
              ],
              note: "The best-received thing you made this year is a skin-care film, and your strongest experience is a longevity institute. The aisle the makeup buyer is leaving for is the one your crowd already reads you in.",
            },
            {
              id: "scent-comeback",
              label: "A scent brought back",
              sub: "Sensuous Nude · archive",
              typical: 30,
              ceiling: 38,
              best: {
                brandName: "Sephora",
                title: "Marc Jacobs Beauty global relaunch",
                pts: 38,
              },
              received: 0,
              own: [{ title: "Sensuous Nude", pts: 28 }],
              note: "One return on the record and it was a listing, not a launch — a single customer review was the evidence, no campaign, and the lane graded below the floor an empty one gets. This is the lane the fragrance crowd's nostalgia trade runs in, and the house has not played it.",
            },
            {
              id: "gift-set",
              label: "A scent as a gift set",
              sub: "Pleasures · capsule, collab",
              typical: 31,
              ceiling: 38,
              best: {
                brandName: "Rhode",
                title: "Summer Station snap-on lip cases",
                pts: 39,
              },
              own: [
                { title: "Ladurée Pleasures box", pts: 25 },
                { title: "Pleasures duo", pts: 12 },
              ],
              note: "Your other fragrance plays are gift sets — a duo, a macaron box in an airport — graded a third below the field's drops and read by nobody. The scent that grows is the one sold as an object of its own, not the one wrapped for someone else.",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Your makeup is coded for craft and nothing else, while the makeup that climbed past you is coded for fandom and scarcity in most of its rows. Your scent plays are the only ones on the shelf with a secret and a sellout — the grammar the growing category speaks.",
          title: "Which strategy each category plays",
          provenance: "measured",
          note: "Your plays this year split by category, against the five cultural strategies — how much of each shelf carries each strategy, on one scale across the grid, with the beauty brand that climbed past you on makeup as the comparison row. Tap a cell for the read.",
          cols: [
            "Fandom",
            "Identity signal",
            "Aesthetic innovation",
            "Scarcity",
            "Opacity",
          ],
          rows: [
            {
              label: "Your fragrance plays",
              cells: [
                {
                  v: 0,
                  note: "None coded. The crowd already treats Glimmer's teaser like a fandom object — it was read before it launched — and the record has no row for it.",
                },
                {
                  v: 4,
                  note: "One play. A scent is an identity signal by nature; the shelf plays it as a launch.",
                },
                {
                  v: 16,
                  note: "Four plays — the bottle, the campaign, the gourmand as craft.",
                },
                {
                  v: 12,
                  note: "Three plays — the limited-quantities capsule, the gift sets. The only scarcity on your shelf that is a fragrance's own sellout rather than a retailer's exclusive.",
                },
                {
                  v: 4,
                  note: "One play — 'a spark, a glow, coming soon': the teaser, the one thing on your record that withheld anything. It was received at sixty.",
                },
              ],
            },
            {
              label: "Your makeup plays",
              cells: [
                {
                  v: 0,
                  note: "Zero, on the largest shelf you have — thirty-six plays, none coded for a crowd.",
                },
                {
                  v: 0,
                  note: "None. Ambassadors are talent in marketing; a foundation says nothing about its wearer, which is the point of a foundation.",
                },
                {
                  v: 60,
                  note: "Fifteen plays — the hottest cell on your own shelf: the reformulation, the masterclasses, the pop-ups. Makeup as craft, read quietly.",
                },
                {
                  v: 12,
                  note: "Three plays — a retailer exclusive and gift sets. Scarcity as a trade tactic, never a drop calendar.",
                },
                {
                  v: 0,
                  note: "None. Everything about Double Wear was announced, dated and toured.",
                },
              ],
            },
            {
              label: "Your skin plays",
              cells: [
                {
                  v: 0,
                  note: "None coded — though Night Repair has the closest thing to a loyal crowd in the house.",
                },
                {
                  v: 8,
                  note: "Two plays — the Skin Longevity Institute, the strongest identity play you own.",
                },
                {
                  v: 24,
                  note: "Six plays — the films, the institute, the sets.",
                },
                {
                  v: 8,
                  note: "Two plays — anniversary and retailer sets.",
                },
                {
                  v: 0,
                  note: "None.",
                },
              ],
            },
            {
              label: "Rhode, makeup",
              cells: [
                {
                  v: 68,
                  note: "Seventeen fandom plays on a makeup shelf — hoodies, a lip case, a waitlist. The makeup that grows in this category is played as a crowd, and it is six places above you.",
                },
                {
                  v: 32,
                  note: "Eight plays: the founder's face and the glaze look the crowd adopted as an identity.",
                },
                {
                  v: 64,
                  note: "Sixteen plays — craft in service of a crowd, not instead of one.",
                },
                {
                  v: 60,
                  note: "Fifteen plays and the highest scarcity fit in beauty: the sellout is the strategy.",
                },
                {
                  v: 48,
                  note: "Twelve plays — mystery drops, unannounced restocks. Makeup sold like a fragrance.",
                },
              ],
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Fragrance has three new crowds walking in — young women through a mist, young men for the first time, millennials trading up — and makeup has one walking out, to the skin aisle. Makeup's door is now a lip liner and a blush.",
          title: "Who is walking into each category",
          provenance: "observed",
          note: "Four crowds, scored for how much of the year's category momentum each one carries, and the clock each runs on — a launch spike or capital that compounds. Tap a crowd for what it is doing.",
          rows: [
            {
              id: "gen-z-women",
              label: "Gen Z women",
              context: "mists, minis, layering, perfumetok",
              score: 88,
              role: "Fragrance's new buyer",
              horizon: "short",
              drivers: [
                "Walks in at a body mist and a mini — mists' share of prestige fragrance units nearly doubled in three years, minis are two in five units",
                "Buys scent as a statement and a collection: layering, decants, the dupe as an entry ticket to the real thing",
                "Her makeup spend went to skin — six in ten want makeup that is skincare — and to lip liner and blush, not base",
                "Already read Glimmer's teaser at sixty before the bottle existed",
              ],
            },
            {
              id: "young-men",
              label: "Teenage boys and young men",
              context: "fragrance spend up forty-four percent in a year",
              score: 76,
              role: "The buyer makeup never had",
              horizon: "short",
              drivers: [
                "A category that used to be a gift is now a signature bought for oneself, taught on a feed",
                "Trades up fast — from a mass body spray to a designer eau de parfum to a niche house inside two years",
                "Has no equivalent in makeup: there is no new cohort walking onto the colour wall",
                "The house's Kilian and Tom Ford are the top of his ladder; nothing you own is the bottom of it",
              ],
            },
            {
              id: "millennials",
              label: "Millennials trading up",
              context: "eau de parfum and parfum, the luxury tier",
              score: 66,
              role: "The price of a bottle",
              horizon: "long",
              drivers: [
                "Bought the same number of bottles and paid five percent more for each — the concentration, the niche house, the fifty-millilitre instead of the thirty",
                "This is where the house's growth actually sits: Le Labo, Tom Ford, Kilian, Jo Malone",
                "In makeup the same buyer replaced foundation with a tinted skincare and kept the lipstick",
              ],
            },
            {
              id: "gen-x",
              label: "Gen X and boomers",
              context: "the foundation buyer moving to skin",
              score: 38,
              role: "Makeup's leaving buyer",
              horizon: "long",
              drivers: [
                "The loyal Double Wear customer, and nobody younger is replacing her",
                "Moving her money to skin care — Night Repair, Re-Nutriv — the aisle that grew nine percent and reads you best",
                "Buys a relaunch, not a drop; she is why the reformulation sold and why it was not talked about",
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves, none of them a campaign: a ladder for the scent already being read, a numbered return for the scents the forums petition for, a makeup drop where makeup still grows — two and a half points together.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Glimmer gets a ladder — a mist and a ten-millilitre at the bottom, the parfum at the top, restocked on dates and gated through the pop-up crowd first",
              itemType: "capsule",
              window:
                "The mini and the mist for the holiday window, the parfum in the spring; restocks announced a week ahead, four a year",
              strategies: [
                { code: "scarcity", fit: 0.8 },
                { code: "identity_signal", fit: 0.6 },
                { code: "fandom", fit: 0.5 },
              ],
              why: "The crowd growing fragrance walks in at a mist and a mini — two in five prestige units are minis — and trades up over years. Glimmer is your best-read launch and is sold at one size and one price. A ladder turns a launch into a franchise the way Kilian's cocktail minis did, and a restock calendar gives the bottle the sellout cycle beauty's scarcity runs on.",
              effect: {
                label: "CIQ",
                delta: 1.0,
                series: [0, 0.3, 0.6, 0.85, 1.0],
              },
              precedents: 3,
              reception:
                "beauty's scarce drops are received at 40 to 53 when the crowd is already waiting; Glimmer's own teaser read 60",
              similar: [
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title: "Summer Station Snap-On Lip Cases (Minori)",
                  pts: 38.5,
                },
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title: "Summer 2026 Limited Edition Waitlist Initiation",
                  pts: 32.8,
                },
                {
                  brand: "ouai",
                  brandName: "OUAI",
                  title: "Limited-Edition Palo Santo Leave-In",
                  pts: 33.3,
                },
              ],
            },
            {
              name: "The scents the forums petition for come back numbered — Beyond Paradise and Intuition, the original formulas disclosed, one run each, the archive told as a story rather than listed",
              itemType: "archive_reissue",
              window:
                "Announced in January, on sale in March; a second scent each autumn while the petitions keep coming",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.7 },
                { code: "opacity", fit: 0.3 },
              ],
              why: "Fragrance's nostalgia trade is a genre of its own — decants, resale, 'they don't make it like this any more' — and your one return on the record was a listing with a customer review for a launch, graded below the floor. A disclosed, numbered return is what the connoisseur crowd asks for, and the field's best comebacks this year came back because the fans asked. Your archive lane is the weakest on your shelf and the cheapest to fill.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.25, 0.5, 0.7, 0.8],
              },
              precedents: 3,
              reception:
                "beauty's comebacks this year are graded 34 to 38 and read as cult returns; the board's best return is a 71",
              similar: [
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: "Marc Jacobs Beauty Global Relaunch",
                  pts: 37.6,
                },
                {
                  brand: "ouai",
                  brandName: "OUAI",
                  title: "Body Crème Shibuya Reissue",
                  pts: 34.0,
                },
                {
                  brand: "ferrari",
                  brandName: "Ferrari",
                  title: "Ferrari 250 GTO restoration honoured at Villa d'Este",
                  pts: 71.4,
                },
              ],
            },
            {
              name: "Double Wear becomes skin — a tint with the Night Repair story in it, a blush and a lip liner in the three pockets that grow, dropped to the pop-up crowd and shot on their camera, not a bus tour",
              itemType: "capsule",
              window:
                "A limited first drop in February when the base season turns, permanent by summer; the crowd's films before the campaign's",
              strategies: [
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "fandom", fit: 0.5 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "Makeup is not flat everywhere: lip liner is the fastest-growing segment on the wall, blush and bronzer grow double digits, and six in ten young buyers want makeup that is skincare. Your base buyer is leaving for the skin aisle, where the crowd already reads you best. Eighteen foundation plays were read twice; a drop the crowd films itself is the format the field's climbers use.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.2, 0.4, 0.6, 0.7],
              },
              precedents: 3,
              reception:
                "beauty's crowd-carried plays are graded 29 to 39 and say 'viral' on the record; your own Double Wear counter read 53 where it was read at all",
              similar: [
                {
                  brand: "rhode",
                  brandName: "Rhode",
                  title:
                    "Met Gala Mystery Drop (Pocket Bronze, Highlight Milk)",
                  pts: 33.5,
                },
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: '"Mario\'s Beauty Booth" TikTok series',
                  pts: 29.4,
                },
                {
                  brand: "apple",
                  brandName: "Apple",
                  title: '"Shot on iPhone" Campaign (Ongoing Activity)',
                  pts: 88.4,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the brand's measured record and the public facts in the file header, and compound with your current course, not on top of it. Glimmer's reads and the Double Wear record are the measured anchors; every market number is the field's, dated.",
        },
        {
          kind: "trendCompare",
          insight:
            "The gap opens in the first quarter, because the fragrance crowd is already at the door; the makeup drop is the slowest of the three and the one that changes what 'flat' means next year.",
          title: "What the three moves return",
          provenance: "projected",
          note: "Incremental net sales from the Estée Lauder brand's fragrance and makeup, in millions of dollars, added up from October: with the three moves; and on today's course — Glimmer at one size, the archive listed, the next foundation tour. The shaded month is the mini and the mist landing.",
          highlight: {
            from: "2026-11-01",
            to: "2026-11-30",
            label: "the mini and the mist land",
          },
          series: [
            {
              key: "plan",
              label: "The ladder, the return, the drop",
              color: "#FB923C",
              points: [
                { d: "2026-10-01", v: 0 },
                { d: "2026-11-01", v: 12 },
                { d: "2026-12-01", v: 26 },
                { d: "2027-01-01", v: 32 },
                { d: "2027-02-01", v: 44 },
                { d: "2027-03-01", v: 54 },
                { d: "2027-04-01", v: 62 },
                { d: "2027-05-01", v: 70 },
                { d: "2027-06-01", v: 78 },
                { d: "2027-07-01", v: 84 },
                { d: "2027-08-01", v: 92 },
                { d: "2027-09-01", v: 100 },
              ],
            },
            {
              key: "base",
              label: "Today's course",
              color: "#94A3B8",
              ghost: true,
              points: [
                { d: "2026-10-01", v: 0 },
                { d: "2026-11-01", v: 3 },
                { d: "2026-12-01", v: 7 },
                { d: "2027-01-01", v: 9 },
                { d: "2027-02-01", v: 12 },
                { d: "2027-03-01", v: 15 },
                { d: "2027-04-01", v: 18 },
                { d: "2027-05-01", v: 21 },
                { d: "2027-06-01", v: 24 },
                { d: "2027-07-01", v: 26 },
                { d: "2027-08-01", v: 29 },
                { d: "2027-09-01", v: 32 },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.5,
          body: "About two and a half points on your published score, from 50.5 to roughly 53, most of it from a scent you already launched and an archive you already own. In money, on the order of a hundred million dollars of incremental sales by next September, front-loaded because the fragrance crowd needs no building. The makeup move is the smallest, and the one that decides whether flat becomes growth.",
        },
        {
          kind: "modelView",
          body: "Fragrance is growing for two reasons that have nothing to do with the house. The category is trading up — the same number of bottles, each sold for more — and a crowd that never bought fragrance is walking in at the bottom: young women through a mist and a mini, young men for the first time. The house owns the top of the ladder that crowd climbs.\n\nMakeup is flat because nobody new is walking onto the colour wall. Its dollars come from price, its units are leaving, and the leaving buyer is going to the skin aisle — where your crowd already reads you best. Where makeup is a utility it shrinks; where it is a statement it grows. Fragrance is a statement by nature.\n\nYour own record says the same: one scent launch read three times in four, one foundation relaunch read twice in eighteen. The answer is not to spend less on makeup or more on fragrance. It is to sell the scent as a ladder, bring back the bottles the connoisseurs ask for, and take makeup to the pockets where it still grows — on the crowd's camera, not on a bus.",
        },
      ],
    },
    {
      id: "china-without-travel-retail",
      // the lead move is a room — an authored place is the format China reads
      itemType: "experience",
      type: "geo",
      question: "How to win back consumers in China beyond travel retail?",
      aliases: [
        "wheres the biggest opportunity to win back china without travel retail",
        "where is the biggest opportunity to win back china without travel retail",
        "where is the biggest opportunity to win back china",
        "how do we win back china without travel retail",
        "how to win back china without travel retail",
        "how do we win back china",
        "how to win back china",
        "biggest opportunity in china",
        "win back china",
        "china without travel retail",
      ],
      askedOn: "2026-09-25",
      blocks: [
        {
          kind: "readout",
          provenance: "observed",
          verdict:
            "China is coming back to La Mer, Le Labo and your festival rank — not to your story. The opening is a place of your own there.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The house has won China back on the scoreboard, while the story of the year belongs to its fragrance and its cream. For this brand, winning China back no longer means selling more; it means being talked about between the festivals.",
          items: [
            {
              label: "Mainland China, the house",
              value: "+9%",
              hint: "the year's organic growth, six consecutive quarters of share gain, about a fifth of the group — led by La Mer, Le Labo, Tom Ford and Jo Malone",
            },
            {
              label: "Travel retail",
              value: "15%",
              hint: "of the business now, reset from the daigou years; mainland duty free fell this year on the airport operator change — the channel the question leaves out",
            },
            {
              label: "Estée Lauder at 618",
              value: "#1 · #2",
              hint: "first on Douyin, second on Tmall behind SkinCeuticals — the festival scoreboard, in skincare, in your own livestream room",
            },
            {
              label: "Innovation made in Shanghai",
              value: "30%",
              hint: "of the house's global innovation now comes from China for China — a Re-Nutriv oil, a treatment lotion in the global top ten — told in trade press only",
            },
          ],
        },
        {
          kind: "geoCompare",
          insight:
            "Your record works hardest at home and least in the market you are asking about: three consumer plays on the mainland this year, none read. The only China praise on your shelf came from the duty-free counters the question excludes.",
          title: "Where your record works, by market",
          provenance: "measured",
          metric: "Cultural presence",
          focus: "china",
          note: "Every market on your shelf this year — how hard your measured record works there, plays graded and read, on one scale. Hainan and the airports are drawn apart so the excluded channel can be seen. No Chinese search or press series sits behind the index. Tap a market to read it against China.",
          markets: [
            {
              id: "china",
              label: "Mainland China",
              x: 86,
              y: 15,
              value: 12,
              delta: 0.6,
              note: "Three consumer-facing plays — an actor's event in July, a global makeup ambassador, a film — and none was read in any window. Your China average is the lowest of any brand on the board with four or more plays there.",
            },
            {
              id: "hainan",
              label: "Hainan & duty free",
              x: 82.5,
              y: 19.5,
              value: 38,
              delta: 2.4,
              note: "The Playhouse of Dreams at Sanya, the Stanley set, the Changi pop-up — the only China-adjacent plays on your shelf anyone praised, and all of it trade press. This is the channel the question leaves out, and it is where your China culture has been living.",
            },
            {
              id: "na",
              label: "North America",
              x: 26.3,
              y: 11.4,
              value: 52,
              delta: 3.1,
              note: "Nia Long, the Double Wear bus tours, the Chicago pop-up, Glimmer with Hailee Steinfeld — the plays that were read were read here.",
            },
            {
              id: "uk",
              label: "United Kingdom",
              x: 50.9,
              y: 7.5,
              value: 44,
              delta: 2.2,
              note: "Harrods, the Heathrow counter received at fifty-three, the Ladurée airport box. Read, but mostly in transit.",
            },
            {
              id: "singapore",
              label: "Singapore",
              x: 80.3,
              y: 25.3,
              value: 30,
              delta: 1.0,
              note: "The Paragon Atrium pop-up is the second-strongest play on your whole shelf and was never read; five plays in the city, all silent.",
            },
            {
              id: "korea",
              label: "South Korea",
              x: 87,
              y: 12.8,
              value: 28,
              delta: 0.8,
              note: "IU at Gangnam and Shinsegae, three pop-ups for one foundation — well graded, read by nobody. An ambassador's pop-up is news for a day.",
            },
            {
              id: "india",
              label: "India",
              x: 73.4,
              y: 19.1,
              value: 20,
              delta: 0.5,
              note: "Two family campaigns; one registered once with no valence. Forest Essentials arrives in the house this year and may change the picture.",
            },
            {
              id: "gulf",
              label: "The Gulf",
              x: 67.1,
              y: 17.2,
              value: 14,
              delta: 0.3,
              note: "One retailer event in Kuwait, silent.",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The market is turning toward your kind of product — efficacy skincare from an international house, bought for feeling, craft and a claim of repair. That is the little brown bottle's brief; nobody in China has been told the bottle is now made there.",
          title: "What the Chinese market is saying",
          provenance: "observed",
          note: "Eight public numbers from the last year, read as signals rather than results. Sparklines are the last readings where a series exists.",
          rows: [
            {
              label: "Cosmetics retail, June",
              context:
                "the strongest month since late 2024; the half-year up six percent against total retail up one",
              value: "+12.6%",
              delta: 12.6,
              spark: [60, 64, 70, 74, 82, 100],
            },
            {
              label: "Prestige at 618",
              context:
                "beauty overall fell two percent and the international houses took the skincare scoreboards — SkinCeuticals first on Tmall, you first on Douyin, La Mer third",
              value: "the counter-attack",
            },
            {
              label: "Proya, the local giant",
              context:
                "the namesake brand down seven percent in the first half after four years of taking share; Mao Geping up a quarter",
              value: "−7%",
              delta: -7,
              spark: [100, 104, 108, 106, 100, 93],
            },
            {
              label: "Douyin, the recruitment engine",
              context:
                "over half of the house's China business is online; your own livestream room beat every creator's room at 11.11",
              value: "#1 store room",
            },
            {
              label: "'Instant repair'",
              context:
                "the fastest-rising claim on Xiaohongshu this year — the triangle is emotion, aesthetics, efficacy",
              value: "fastest-rising claim",
              spark: [30, 38, 48, 62, 80, 100],
            },
            {
              label: "Gen Z buying for feeling",
              context:
                "share of Gen Z who name emotional satisfaction as the reason they buy; the emotional-purchase market past three trillion yuan",
              value: "64%",
            },
            {
              label: "Le Labo's villa, Wukang Road",
              context:
                "a fifty-square-metre lab in a heritage house — visitors a day in its first month, weekends beating the flagship",
              value: "2,000+",
            },
            {
              label: "Chinese travellers to Japan",
              context:
                "down by more than half in August; the shopper who bought at Ginza is at home, or in Seoul",
              value: "−57%",
              delta: -57,
              spark: [100, 92, 80, 66, 52, 43],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "China reads two things — a place a house built there and a partner it already loves on the box — and ignores a famous face flown in for an evening. Your mainland plays are all faces, and you have never built a room.",
          title: "What registers in China, on the board",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "The ninety-seven China plays on the whole board this year, by the kind of play they were. Bands are the field's range on each lane — typical to ceiling; the ring is the field's strongest play there, the dots are yours. Received = the best presence the crowd gave any of yours. Tap a lane for the read.",
          rows: [
            {
              id: "place",
              label: "A place you built there",
              sub: "exhibition · store · room",
              typical: 42,
              ceiling: 47,
              best: {
                brandName: "Saint Laurent",
                title: "No. 223 exhibition, Rive Droite Beijing",
                pts: 50,
              },
              status: "recommended",
              note: "The strongest lane in China on the board and the best-received: Saint Laurent's photography show in Beijing read at sixty-seven, Hermès, Louis Vuitton and Nike in Shanghai at sixty. A room the crowd can walk into is the one format every house that registered in China used. You have none on the record.",
            },
            {
              id: "partner",
              label: "A local partner on the box",
              sub: "collab · IP",
              typical: 36,
              ceiling: 39,
              best: {
                brandName: "Duolingo",
                title: "MINISO China collaboration",
                pts: 37,
              },
              received: 27,
              own: [{ title: "Travel Retail × Stanley set", pts: 36 }],
              note: "The other lane China reads: a partner it already loves — Luckin's latte with Duolingo is the best-received China play on the board at seventy-three, MINISO at forty, Pop Mart, Jay Chou. Your one partner in Asia is an American tumbler in duty free, read at twenty-seven by the trade.",
            },
            {
              id: "face",
              label: "A famous face, flown in",
              sub: "ambassador · appearance",
              typical: 22,
              ceiling: 30,
              best: {
                brandName: "Starbucks",
                title: "Starbucks × Jay Chou",
                pts: 37,
              },
              own: [
                { title: "Event with Zhu Yilong", pts: 26 },
                { title: "Xin Zhilei, global makeup face", pts: 24 },
                { title: "Liu Haocun, the film", pts: 16 },
              ],
              note: "Your whole mainland record is in this lane, the quietest on the board: Gucci's evening, Dior's, UGG's and yours all read as nothing. The one face that worked is Jay Chou's, because he made a drink. The actor at your July event signed with a Chinese fragrance house a month later.",
            },
            {
              id: "duty-free",
              label: "The airport and Hainan",
              sub: "travel retail",
              typical: 27,
              ceiling: 34,
              best: {
                brandName: "Aesop",
                title: "Women's Library, Hainan",
                pts: 38,
              },
              received: 53,
              own: [
                { title: "Playhouse of Dreams, Sanya", pts: 25 },
                { title: "DVF pop-up, Changi", pts: 27 },
                { title: "Heathrow counter", pts: 18 },
              ],
              note: "The only lane where your Asia was ever praised — fifty-three for a pop-up in Sanya and one in Singapore's airport — and every read came from a duty-free trade title. This is the channel the question sets aside, and it is where your China culture has been living.",
            },
            {
              id: "corporate",
              label: "A corporate milestone",
              sub: "innovation centre · expo",
              typical: 12,
              ceiling: 17,
              own: [
                { title: "Hainan Expo pavilion", pts: 17 },
                { title: "Minhang innovation centre", pts: 12 },
              ],
              received: 40,
              note: "The Shanghai innovation story exists on your shelf as a trade-press item that was read once. Thirty percent of the house's innovation now comes from China for China; the bottle has not been told that in public.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Every play that landed was a Shanghai room or a Chinese partner; every silent one a global face with a Chinese evening. And local can go wrong — the most local-looking play on the board read worst of all. Made for China is the rule; made with China is the safeguard.",
          title: "Made for China, against how it read",
          provenance: "measured",
          x: {
            label: "Made for China",
            low: "flown in",
            high: "made there",
            hint: "how much of the play was built for the market — a Chinese place, partner, craft or story — against a global asset with a Chinese appearance",
          },
          y: {
            label: "How it read",
            low: "silent or worse",
            high: "praised",
            hint: "the crowd's reception of the play on your measured record — presence and praise, on a 0 to 100 scale",
          },
          quadrants: {
            tr: "Made there, and read",
            tl: "Flown in, and read",
            br: "Made there, and wrong",
            bl: "Flown in, ignored",
          },
          note: "Twenty of the board's China plays this year and yours. Across is how much of the play was made for the market; up is how the crowd received it. Dot size is the play's graded strength; the orange dots are yours. Tap a dot for the read.",
          points: [
            {
              id: "luckin",
              label: "Luckin × Duolingo latte",
              era: "A local partner",
              color: "#B388FF",
              x: 95,
              y: 92,
              w: 36,
              note: "The best-received China play on the board: a green owl on a coffee cup from the chain every office already drinks. Nothing was flown in.",
            },
            {
              id: "ysl-beijing",
              label: "Saint Laurent No. 223, Beijing",
              era: "A place",
              color: "#4ADE80",
              x: 82,
              y: 88,
              w: 50,
              note: "A photography exhibition in the house's own Beijing space — the strongest China play on the board and read at sixty-seven. A Paris house, a Beijing room, a story worth a visit.",
            },
            {
              id: "hermes-shanghai",
              label: "Hermès, In the Making",
              era: "A place",
              color: "#4ADE80",
              x: 78,
              y: 80,
              w: 47,
              note: "Craft shown in Shanghai — the artisans at their benches. Read at sixty. Guochao's third act rewards exactly this: craft and depth over a flag.",
            },
            {
              id: "lv-shanghai",
              label: "Louis Vuitton concept store",
              era: "A place",
              color: "#4ADE80",
              x: 70,
              y: 80,
              w: 44,
              note: "A store that is a destination first — the boat, the café, the exhibition — read at sixty. Le Labo's villa on Wukang Road is the same play at fifty square metres.",
            },
            {
              id: "nike-shanghai",
              label: "Jordan 'The One', Shanghai",
              era: "A place",
              color: "#4ADE80",
              x: 75,
              y: 80,
              w: 39,
              note: "A house for a shoe in Shanghai, read at sixty — while the brand's China sales fell by a sixth. A room reads even when the numbers do not.",
            },
            {
              id: "valentino",
              label: "Valentino, Sanlitun",
              era: "A place",
              color: "#4ADE80",
              x: 72,
              y: 78,
              w: 36,
              note: "An installation in Beijing's fashion street, read at sixty.",
            },
            {
              id: "miniso",
              label: "Duolingo × MINISO",
              era: "A local partner",
              color: "#B388FF",
              x: 90,
              y: 70,
              w: 37,
              note: "A mascot in the shop every teenager walks through — read at forty.",
            },
            {
              id: "jay-chou",
              label: "Starbucks × Jay Chou",
              era: "A local partner",
              color: "#B388FF",
              x: 88,
              y: 60,
              w: 37,
              note: "A face that made something — a drink with his name on it, not an appearance. Read at thirty-three; the only celebrity play in China that registered.",
            },
            {
              id: "popmart",
              label: "McDonald's × Pop Mart",
              era: "A local partner",
              color: "#B388FF",
              x: 92,
              y: 55,
              w: 37,
              note: "The emotional-value template on a meal — read at twenty-seven.",
            },
            {
              id: "aesop-hainan",
              label: "Aesop's Women's Library, Hainan",
              era: "Duty free",
              color: "#94A3B8",
              x: 50,
              y: 55,
              w: 38,
              note: "A room, in duty free — read at forty. The one beauty rival with China plays, and all three are in Hainan.",
            },
            {
              id: "el-hainan",
              label: "Playhouse of Dreams, Sanya",
              era: "Duty free",
              color: "#FB923C",
              x: 55,
              y: 65,
              w: 25,
              note: "Your best-received Asia play — fifty-three, from a duty-free trade title. A room, which is the point; in an airport mall, which is the problem.",
            },
            {
              id: "el-stanley",
              label: "Travel Retail × Stanley",
              era: "Duty free",
              color: "#FB923C",
              x: 20,
              y: 40,
              w: 36,
              note: "An American tumbler in Asian duty free — read at twenty-seven. Your only partner play in the region, and nothing about it is Chinese.",
            },
            {
              id: "el-minhang",
              label: "Minhang innovation centre",
              era: "Yours, on the mainland",
              color: "#FB923C",
              x: 60,
              y: 40,
              w: 12,
              note: "Made there, read once at forty — by the trade. The story the consumer has not been told.",
            },
            {
              id: "gucci-wuhan",
              label: "Gucci, Wuhan evening",
              era: "A face, flown in",
              color: "#FF5A76",
              x: 40,
              y: 10,
              w: 30,
              note: "An ambassador's evening — silent.",
            },
            {
              id: "dior-face",
              label: "Dior, Zhang Linghe",
              era: "A face, flown in",
              color: "#FF5A76",
              x: 35,
              y: 10,
              w: 28,
              note: "Silent.",
            },
            {
              id: "ugg-yuqi",
              label: "UGG, Yuqi",
              era: "A face, flown in",
              color: "#FF5A76",
              x: 38,
              y: 12,
              w: 26,
              note: "Silent.",
            },
            {
              id: "el-zhu",
              label: "Your event with Zhu Yilong",
              era: "Yours, on the mainland",
              color: "#FB923C",
              x: 36,
              y: 8,
              w: 26,
              note: "A July evening with an actor, never read — and a month later he signed as a Chinese fragrance house's first global ambassador. A face rented for an evening belongs to whoever gives him a story.",
            },
            {
              id: "el-xin",
              label: "Xin Zhilei, global makeup face",
              era: "Yours, on the mainland",
              color: "#FB923C",
              x: 30,
              y: 12,
              w: 24,
              note: "A Venice Best Actress as your global makeup face, read once by a niche title and then ten silent windows. The roster is strong; nothing has been built around it.",
            },
            {
              id: "el-liu",
              label: "Liu Haocun, the film",
              era: "Yours, on the mainland",
              color: "#FB923C",
              x: 32,
              y: 6,
              w: 16,
              note: "Silent.",
            },
            {
              id: "lulu-wall",
              label: "lululemon, yoga on the Great Wall",
              era: "A face, flown in",
              color: "#FF5A76",
              x: 85,
              y: 4,
              w: 47,
              note: "The most local-looking play on the board and the worst-read anywhere: minus eighty, for cultural insensitivity, in every paper from the Guardian to Caixin. Made in China is not the same as made with China — the safeguard is a Chinese partner in the room.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The crowd to win back is not the daigou buyer, gone with the discount. It is the festival buyer who hears nothing between festivals and the young buyer who wants repair and a feeling — both reachable from a place, neither from a face.",
          title: "Who there is to win back",
          provenance: "observed",
          note: "Four Chinese crowds, scored for how much of the brand's mainland opportunity each one carries, and the clock each runs on — a launch spike or capital that compounds. Tap a crowd for what it is doing.",
          rows: [
            {
              id: "festival",
              label: "The festival buyer",
              context: "618 and 11.11, in your own Douyin room",
              score: 84,
              role: "Already yours, twice a year",
              horizon: "short",
              drivers: [
                "Put you first on Douyin and second on Tmall at 618 — full price, in the house's own room, not a creator's",
                "Buys skincare on a claim and a coupon and hears nothing from you until the next festival",
                "Management's word is 'less promotional' — the reason to come back has to be something other than a discount",
              ],
            },
            {
              id: "repair",
              label: "Gen Z, buying for feeling",
              context: "Xiaohongshu — emotion, aesthetics, efficacy",
              score: 78,
              role: "The claim is repair",
              horizon: "long",
              drivers: [
                "'Instant repair' is the fastest-rising claim on the platform this year; two in three buy for emotional satisfaction",
                "Wants craft, region and a story — guochao's third act — not a flag on a box",
                "Knows the little brown bottle as her mother's; does not know it is now made in Shanghai for her",
              ],
            },
            {
              id: "citywalk",
              label: "The city-walk crowd",
              context: "Wukang Road, Sanlitun, Chengdu's teahouses",
              score: 70,
              role: "Goes where there is a room",
              horizon: "long",
              drivers: [
                "Two thousand a day at a fifty-square-metre fragrance lab in a heritage villa; Lancôme's lacquerware teahouse in Chengdu; Louis Vuitton's Chengdu Chill",
                "Reads a place as a statement and posts it — every China play on the board that landed was somewhere you could stand",
                "Has never been given an Estée Lauder address worth walking to",
              ],
            },
            {
              id: "daigou",
              label: "The ex-daigou buyer",
              context: "bought at a discount through Hainan",
              score: 34,
              role: "Gone with the discount",
              horizon: "long",
              drivers: [
                "A fifth of the old China number and the reason for a two-hundred-million-dollar settlement",
                "Was never yours — she was the reseller's, at the reseller's price",
                "Comes back only as a full-price customer, which means as a member of something",
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves, none a face and none a coupon: a room in Shanghai for the brown bottle's Chinese science, a museum on the compact the crowd already collects, a club where your own livestream room already is — two and a half points together.",
          title: "Three moves, built for the mainland",
          provenance: "projected",
          plays: [
            {
              name: "The Little Brown Bottle House, Shanghai — Night Repair's Chinese lab told as a room in a Wukang Road villa: the formulas made in Minhang for China shown as Chinese science, a night-repair ritual you can book, open for 11.11 and kept",
              itemType: "experience",
              window:
                "Opens the week before 11.11, when the festival crowd is already looking; a second room in Chengdu for the spring",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "opacity", fit: 0.4 },
              ],
              why: "A place a house built there is the one format every brand that registered in China used, and Le Labo's own heritage villa draws two thousand a day at fifty square metres. You have the strongest codes in beauty after Aesop, a bottle the crowd's mother owned, thirty percent of the house's innovation made in Shanghai, and a market whose fastest-rising claim is repair. Nobody has been told any of it in a room.",
              effect: {
                label: "CIQ",
                delta: 1.1,
                series: [0, 0.35, 0.7, 0.95, 1.1],
              },
              precedents: 3,
              reception:
                "the board's authored places in China are graded 38 to 50 and received at 53 to 67 — the best-read lane in the market; your own rooms in Asia read 53 in duty free",
              similar: [
                {
                  brand: "saint-laurent",
                  brandName: "Saint Laurent",
                  title: "No. 223 Photography Exhibition, Rive Droite Beijing",
                  pts: 49.7,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "In the Making exhibition, Shanghai",
                  pts: 44.9,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title: "The Louis Concept Store, Shanghai",
                  pts: 43.9,
                },
              ],
            },
            {
              name: "Estée Blue meets a Chinese museum — the collectible compact the crowd already resells, made with a museum's archive or a Chengdu lacquer atelier, numbered, dropped first in your own Douyin room for Mid-Autumn and again for the Lunar New Year",
              itemType: "collab",
              window:
                "Mid-Autumn in September is the first edition, the Lunar New Year edition in January; each numbered, each in the own room a week before the counters",
              strategies: [
                { code: "scarcity", fit: 0.7 },
                { code: "fandom", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.6 },
              ],
              why: "A partner the market already loves is the other lane China reads — Luckin, MINISO, Pop Mart, Jay Chou — and your only partner in Asia is a tumbler in duty free. The crowd already collects and resells your compacts, and guochao's third act sells craft, region and museum depth: Kans took six million views with the Suzhou Museum. A Chinese partner in the room is also the safeguard the Great Wall play never had.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.25, 0.5, 0.7, 0.8],
              },
              precedents: 3,
              reception:
                "the board's local-partner plays in China are graded 36 to 39 and received at 27 to 73; the beauty field's collabs read 30 to 40",
              similar: [
                {
                  brand: "duolingo",
                  brandName: "Duolingo",
                  title: "Duolingo × MINISO China",
                  pts: 36.6,
                },
                {
                  brand: "mcdonalds",
                  brandName: "McDonald's",
                  title: "McDonald's China × Pop Mart",
                  pts: 37.4,
                },
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks × Jay Chou",
                  pts: 36.7,
                },
              ],
            },
            {
              name: "The own room becomes a club — the Douyin store livestream turned into a weekly show with a ritual, Wang Manyu's table and Xin Zhilei's masterclass, China-made launches to members a month before the festival, no coupon",
              itemType: "community",
              window:
                "The first show the week after 11.11, when the festival buyer goes quiet; membership opened to that month's buyers first",
              strategies: [
                { code: "fandom", fit: 0.7 },
                { code: "identity_signal", fit: 0.5 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "Your own room already beats every creator's room at the festivals and protects the price a rented room does not. The record grades your community's rituals, owned spaces and exclusivity at the floor and calls the loyalty list a discount scheme; the festival buyer chose you twice this year and hears nothing in between. A show with a ritual and the ambassadors you already pay is the cheapest community the house could build.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.15, 0.35, 0.5, 0.6],
              },
              precedents: 3,
              reception:
                "beauty's best-received community plays this year read 47 to 53; the board's best community play in China, a Starbucks night in a river town, read 67",
              similar: [
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: "Summer Club",
                  pts: 36,
                },
                {
                  brand: "sephora",
                  brandName: "Sephora",
                  title: "Quiet Hours",
                  pts: 34,
                },
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Purple Night, Star River",
                  pts: 33,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the brand's measured record and the public facts in the file header, and compound with the house's China course, not on top of it. The index carries no Chinese search or press series — every China read here is the crowd's reception of a play, and its absence is a limit of our search, never proof a play went unnoticed.",
        },
        {
          kind: "trendCompare",
          insight:
            "The room does most of the work and does it first, because the crowd that walks to a place is already walking; the club is the slowest line and the one that keeps the festival buyer between festivals.",
          title: "Presence in China, with the slate",
          provenance: "projected",
          note: "The brand's cultural presence on the mainland — the map's index — modelled with and without the three moves, from October; the distance between the lines is the slate. The shaded month is the room opening for 11.11.",
          highlight: {
            from: "2026-11-01",
            to: "2026-11-30",
            label: "the room opens",
          },
          series: [
            {
              key: "with",
              label: "The room, the museum, the club",
              color: "#4ADE80",
              points: [
                { d: "2026-10-01", v: 12 },
                { d: "2026-11-01", v: 20 },
                { d: "2026-12-01", v: 26 },
                { d: "2027-01-01", v: 30 },
                { d: "2027-02-01", v: 35 },
                { d: "2027-03-01", v: 37 },
                { d: "2027-04-01", v: 40 },
                { d: "2027-05-01", v: 42 },
                { d: "2027-06-01", v: 45 },
                { d: "2027-07-01", v: 46 },
                { d: "2027-08-01", v: 47 },
                { d: "2027-09-01", v: 48 },
              ],
            },
            {
              key: "without",
              label: "Today's course",
              color: "#94A3B8",
              ghost: true,
              points: [
                { d: "2026-10-01", v: 12 },
                { d: "2026-11-01", v: 13 },
                { d: "2026-12-01", v: 13 },
                { d: "2027-01-01", v: 14 },
                { d: "2027-02-01", v: 14 },
                { d: "2027-03-01", v: 14 },
                { d: "2027-04-01", v: 15 },
                { d: "2027-05-01", v: 15 },
                { d: "2027-06-01", v: 16 },
                { d: "2027-07-01", v: 16 },
                { d: "2027-08-01", v: 16 },
                { d: "2027-09-01", v: 17 },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.5,
          body: "About two and a half points on your published score, from 50.5 to roughly 53, and the first cultural reads from the mainland on your record — today there are none. In money it rides a market already growing nine percent for the house at full price; the moves change who the growth belongs to, not whether it comes. The room is most of it, and the club is what keeps it.",
        },
        {
          kind: "modelView",
          body: "China has come back to the house without duty free — to the cream, the fragrance houses and the festival rank, not to this brand's story. Your mainland record this year is three evenings with famous faces that nobody wrote about; the only China praise on your shelf came from the airport malls the question sets aside.\n\nThe board is unambiguous about what China reads. Every play that landed was a place a house built there or a partner the market already loved; every play that did not was a global face with a Chinese evening; and the one that tried hardest to look Chinese without a Chinese hand in it read worst of all. Made for China is the rule, made with China the safeguard.\n\nSo the biggest opportunity is not another ambassador and not another festival. It is an address: a room in Shanghai where the brown bottle's Chinese science is a story people can walk into, a museum on the compact the crowd already collects, and a club where your own livestream room already stands — so the buyer who chose you in June has somewhere to be in July.",
        },
      ],
    },
  ],
};
